/** Từ điển tiếng Việt — ngôn ngữ gốc của sản phẩm. */
export const vi: Record<string, string> = {
  // ── Chung ────────────────────────────────────────────────
  'app.name': 'DNSHub',
  'app.tagline': 'Quản trị tên miền Cloudflare',
  'error.network':
    'Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại — nếu vẫn lỗi, máy chủ có thể đang dừng.',
  'error.unexpected': 'Đã xảy ra lỗi không mong muốn.',
  'common.save': 'Lưu',
  'common.saveChanges': 'Lưu thay đổi',
  'common.cancel': 'Huỷ',
  'common.close': 'Đóng',
  'common.on': 'bật',
  'common.off': 'tắt',
  'common.delete': 'Xoá',
  'common.edit': 'Sửa',
  'common.duplicate': 'Nhân bản',
  'common.create': 'Tạo',
  'common.confirm': 'Xác nhận',
  'common.retry': 'Thử lại',
  'common.undo': 'Hoàn tác',
  'common.refresh': 'Làm mới',
  'common.view': 'Xem',
  'common.loading': 'Đang tải…',
  'common.processing': 'Đang xử lý…',
  'common.search': 'Tìm kiếm',
  'common.showPassword': 'Hiện mật khẩu',
  'common.hidePassword': 'Ẩn mật khẩu',
  'common.clearSearch': 'Xoá từ khoá tìm kiếm',
  'common.copy': 'Sao chép',
  'common.closeToast': 'Đóng thông báo',
  'common.copied': 'Đã sao chép',
  'common.back': 'Quay lại',
  'common.backToOverview': 'Về trang tổng quan',
  'common.yes': 'Có',
  'common.no': 'Không',
  'common.none': 'Không có',
  'common.optional': 'không bắt buộc',
  'common.required': 'bắt buộc',
  'common.download': 'Tải về',
  'common.print': 'In',
  'common.enabled': 'Đang bật',
  'common.disabled': 'Đang tắt',
  'common.system': 'Hệ thống',
  'common.default': 'Mặc định',
  'common.never': 'Chưa bao giờ',
  'common.unknown': 'Không rõ',

  // ── Trạng thái UI (docs/08 §8.5) ─────────────────────────
  'state.empty.title': 'Chưa có dữ liệu',
  'state.error.title': 'Không tải được dữ liệu',
  'state.error.body': 'Đã xảy ra lỗi khi gọi máy chủ. Bạn có thể thử lại.',
  'state.forbidden.title': 'Bạn không có quyền xem mục này',
  'state.forbidden.body': 'Hãy liên hệ quản trị viên nếu bạn cần truy cập.',
  'state.notFound.title': 'Không tìm thấy trang',
  'state.notFound.body': 'Đường dẫn không tồn tại hoặc đã bị đổi.',

  // ── Điều hướng ───────────────────────────────────────────
  'nav.group.operate': 'Vận hành',
  'nav.group.admin': 'Quản trị',
  'nav.group.account': 'Tài khoản',
  'nav.overview': 'Tổng quan',
  'nav.domains': 'Tên miền',
  'nav.subdomains': 'Tên miền con',
  'subdomains.title': 'Tên miền con',
  'subdomains.lede':
    'Cắt một nhánh của tên miền rồi giao cho người khác dựng, mà không mở cả vùng DNS.',
  'subdomains.add': 'Tạo tên miền con',
  'subdomains.addTitle': 'Tạo tên miền con mới',
  'subdomains.created': 'Đã tạo tên miền con.',
  'subdomains.count': '{n} tên miền con',
  'subdomains.recordCount': '{n} bản ghi',
  'subdomains.searchPlaceholder': 'Tìm theo tên miền con…',
  'subdomains.emptyTitle': 'Chưa có tên miền con nào',
  'subdomains.emptyBody':
    'Tạo tên miền con để giao một nhánh cho người khác quản lý, ví dụ blog.example.com.',
  'subdomains.col.fqdn': 'Tên miền con',
  'subdomains.col.domain': 'Thuộc tên miền',
  'subdomains.col.records': 'Bản ghi',
  'subdomains.col.shares': 'Chia sẻ',
  'subdomains.col.relation': 'Quan hệ',
  'subdomains.col.created': 'Tạo lúc',
  'subdomains.col.actions': 'Thao tác',
  'subdomains.relation.domain': 'Qua tên miền',
  'subdomains.relation.granted': 'Được chia sẻ',
  'subdomains.field.domain': 'Tên miền gốc',
  'subdomains.field.domainPlaceholder': 'Chọn tên miền…',
  'subdomains.field.label': 'Tên miền con',
  'subdomains.field.labelHint': 'Một nhãn duy nhất, không có dấu chấm — ví dụ blog.',
  'subdomains.field.labelHintWith': 'Sẽ tạo thành {fqdn}',
  'subdomains.noDomainCanCreate':
    'Bạn chưa có tên miền nào cho phép tạo tên miền con. Cần quyền "Tạo tên miền con" trên tên miền đó.',
  'subdomains.detail.lede': 'Một nhánh của {domain}. Bạn chỉ quản lý được bản ghi trong nhánh này.',
  'subdomains.tab.records': 'Bản ghi DNS',
  'subdomains.tab.sharing': 'Chia sẻ',
  'subdomains.record.add': 'Thêm bản ghi',
  'subdomains.record.addTitle': 'Thêm bản ghi trong nhánh',
  'subdomains.record.created': 'Đã thêm bản ghi.',
  'subdomains.record.deleted': 'Đã xoá bản ghi.',
  'subdomains.record.emptyTitle': 'Nhánh này chưa có bản ghi nào',
  'subdomains.record.emptyBody': 'Thêm bản ghi đầu tiên cho {fqdn}.',
  'subdomains.record.nameHint': 'Bản ghi sẽ là {fqdn}',
  'subdomains.share.add': 'Cấp quyền',
  'subdomains.share.addTitle': 'Chia sẻ tên miền con',
  'subdomains.delete.action': 'Xoá tên miền con',
  'subdomains.delete.title': 'Xoá {fqdn}?',
  'subdomains.delete.keepTitle': 'Chỉ xoá tên miền con, GIỮ NGUYÊN bản ghi DNS',
  'subdomains.delete.keepSub':
    'Các bản ghi vẫn chạy bình thường trên Cloudflare, chỉ không còn được quản lý riêng theo nhánh này nữa.',
  'subdomains.delete.purgeTitle': 'Xoá tên miền con VÀ toàn bộ {n} bản ghi DNS trong nhánh',
  'subdomains.delete.purgeSub':
    'Bản ghi bị xoá thật trên Cloudflare. Mọi dịch vụ đang dùng chúng sẽ ngừng hoạt động ngay.',
  'subdomains.delete.purgeWarn':
    'KHÔNG khôi phục được. Sau khi xoá, {fqdn} và mọi tên bên dưới nó sẽ biến mất khỏi Internet.',
  'subdomains.delete.confirmLabel': 'Gõ đúng {fqdn} để xác nhận',
  'subdomains.delete.grantsNote':
    'Dù chọn cách nào, mọi quyền chia sẻ và lời mời đang chờ trên tên miền con này đều bị thu hồi.',
  'subdomains.delete.pendingWarn':
    'Đang có {n} người chờ kích hoạt. Quyền vào nhánh này của họ sẽ bị thu hồi, nhưng thư mời tạo tài khoản đã gửi thì VẪN dùng được — họ vẫn lập được tài khoản rồi đăng nhập vào một nơi trống.',
  'subdomains.delete.done': 'Đã xoá tên miền con. Bản ghi DNS được giữ nguyên.',
  'subdomains.delete.doneWithRecords': 'Đã xoá tên miền con và {n} bản ghi DNS.',
  'subdomains.share.pending': 'Chờ kích hoạt',
  'subdomains.share.pendingSub': 'Chưa có tài khoản — đã gửi thư mời',
  'subdomains.share.pendingExpires': 'Lời mời hết hạn {date}',
  'subdomains.share.revokeInvite': 'Thu hồi lời mời',
  'subdomains.share.inviteRevoked': 'Đã thu hồi lời mời.',
  'subdomains.share.email': 'Email người nhận',
  'subdomains.share.emailHint':
    'Người này sẽ quản lý được bản ghi DNS trong nhánh con. Email chưa có tài khoản sẽ nhận thư mời tạo tài khoản.',
  'subdomains.share.invited':
    'Đã gửi thư mời. Quyền có hiệu lực khi người nhận kích hoạt tài khoản.',
  'subdomains.field.shareEmail': 'Chia sẻ cho (tuỳ chọn)',
  'subdomains.field.shareEmailHint':
    'Bỏ trống thì chỉ tạo tên miền con. Nhập email để chia sẻ luôn — chưa có tài khoản thì hệ thống gửi thư mời.',
  'subdomains.share.granted': 'Đã cấp quyền trên tên miền con.',
  'subdomains.share.revoke': 'Thu hồi quyền',
  'subdomains.share.revoked': 'Đã thu hồi quyền.',
  'subdomains.share.emptyTitle': 'Chưa chia sẻ cho ai',
  'subdomains.share.emptyBody': 'Cấp quyền để người khác quản lý bản ghi trong nhánh này.',
  'subdomains.share.col.user': 'Người dùng',
  'subdomains.share.col.role': 'Mức quyền',
  'subdomains.share.col.effective': 'Quyền hiệu lực',
  'subdomains.share.effectiveCount': '{n} quyền trên bản ghi DNS',
  'subdomains.share.userPlaceholder': 'Chọn người dùng…',
  'subdomains.share.rolePlaceholder': 'Chọn mức quyền…',
  'subdomains.share.roleHint':
    'Những quyền không có nghĩa ở cấp tên miền con (SSL, gói, nameserver, chia sẻ tiếp) sẽ tự bị loại.',
  'subdomains.share.oneLevelNote':
    'Người được chia sẻ chỉ quản lý bản ghi trong nhánh này. Họ KHÔNG tạo được tên miền con cấp hai và không chia sẻ tiếp được.',
  'nav.dns': 'Bản ghi DNS',
  'nav.users': 'Người dùng',
  'nav.roles': 'Quản lý quyền người dùng',
  'nav.domainRoles': 'Quản lý quyền tên miền',
  'nav.permissions': 'Phân quyền tên miền',
  'nav.connections': 'Quản lý kết nối Cloudflare',
  'nav.settings': 'Cài đặt hệ thống',
  'nav.profile': 'Hồ sơ & bảo mật',
  'nav.audit': 'Nhật ký hoạt động',
  'nav.open': 'Mở điều hướng',
  'nav.close': 'Đóng điều hướng',
  'nav.themeToLight': 'Chuyển sang giao diện sáng',
  'nav.themeToDark': 'Chuyển sang giao diện tối',
  // OQ-288 — ba chế độ giao diện.
  'nav.theme.label': 'Chế độ giao diện',
  'nav.theme.light': 'Sáng',
  'nav.theme.dark': 'Tối',
  'nav.theme.auto': 'Tự động',
  'nav.theme.autoNow.light': 'đang sáng',
  'nav.theme.autoNow.dark': 'đang tối',
  'nav.logout': 'Đăng xuất',
  'nav.searchPlaceholder': 'Tìm tên miền, bản ghi, người dùng…',

  // ── Đăng nhập ────────────────────────────────────────────
  'auth.login.title': 'Đăng nhập',
  'auth.login.lede': 'Quản trị tên miền và bản ghi DNS trên nền Cloudflare.',
  'auth.login.email': 'Email',
  'auth.login.password': 'Mật khẩu',
  'auth.login.remember': 'Ghi nhớ đăng nhập',
  'auth.login.forgot': 'Quên mật khẩu?',
  'auth.login.toRegister': 'Chưa có tài khoản? Đăng ký',
  'auth.register.title': 'Tạo tài khoản',
  'auth.register.closed':
    'Hệ thống hiện không nhận đăng ký mới. Nếu bạn cần tài khoản, hãy liên hệ quản trị viên để được mời.',
  'auth.register.lede': 'Đăng ký để tự quản lý tên miền Cloudflare của bạn.',
  'auth.register.submit': 'Đăng ký',
  'auth.register.haveAccount': 'Đã có tài khoản? Đăng nhập',
  'auth.register.sentTitle': 'Kiểm tra hộp thư',
  /* Câu này nói về HỘP THƯ chứ không về tài khoản — cố ý. Máy chủ trả lời y hệt
     nhau cho email đã có và chưa có tài khoản để không ai dò được danh sách
     người dùng; trang mà nói khác đi thì công sức ấy thành vô nghĩa. */
  'auth.register.sentLede': 'Nếu {email} chưa có tài khoản, thư xác minh đang trên đường tới.',
  'auth.register.sentHint':
    'Mở thư và bấm liên kết để bắt đầu dùng. Liên kết chỉ dùng được một lần. Nếu địa chỉ này đã có tài khoản, bạn sẽ nhận được thư nhắc đăng nhập.',
  'auth.verifySignup.title': 'Đang xác minh…',
  'auth.verifySignup.working': 'Chờ một chút, hệ thống đang kích hoạt tài khoản của bạn.',
  'auth.login.submit': 'Đăng nhập',
  'auth.login.submitting': 'Đang đăng nhập…',
  'auth.2fa.title': 'Xác thực hai bước',
  'auth.2fa.lede': 'Nhập mã 6 số từ ứng dụng xác thực, hoặc một mã khôi phục.',
  'auth.2fa.code': 'Mã xác thực',
  'auth.2fa.codeHint': 'Mã 6 số hoặc mã khôi phục 10 ký tự',
  'auth.2fa.trust': 'Tin thiết bị này trong 30 ngày',
  'auth.2fa.submit': 'Xác nhận',
  'auth.2fa.backToLogin': 'Quay lại đăng nhập',
  'auth.forgot.title': 'Quên mật khẩu',
  'auth.forgot.lede':
    'Nhập email của bạn. Nếu tài khoản tồn tại, chúng tôi sẽ gửi liên kết đặt lại.',
  'auth.forgot.submit': 'Gửi liên kết đặt lại',
  'auth.forgot.sent':
    'Nếu email này có tài khoản, liên kết đặt lại đã được gửi. Liên kết hết hạn sau 60 phút.',
  'auth.reset.title': 'Đặt lại mật khẩu',
  'auth.reset.lede': 'Chọn mật khẩu mới cho tài khoản của bạn.',
  'auth.reset.newPassword': 'Mật khẩu mới',
  'auth.reset.confirmPassword': 'Nhập lại mật khẩu mới',
  'auth.reset.submit': 'Đặt lại mật khẩu',
  'auth.reset.done': 'Đã đổi mật khẩu. Mọi phiên đăng nhập cũ đã bị kết thúc.',
  'auth.reset.goLogin': 'Đăng nhập lại',
  'auth.invite.title': 'Kích hoạt tài khoản',
  'auth.invite.lede': '{inviter} mời bạn tham gia với vai trò {role}.',
  'auth.invite.fullName': 'Họ và tên',
  'auth.invite.submit': 'Kích hoạt và đăng nhập',
  'auth.verifyEmail.title': 'Xác minh email',
  'auth.verifyEmail.done': 'Đã xác minh. Email mới của bạn là {email}.',
  'auth.mismatch': 'Hai mật khẩu không khớp.',
  'auth.mustChangePassword':
    'Quản trị viên vừa đặt lại mật khẩu cho bạn. Hãy đổi sang mật khẩu của riêng bạn trước khi dùng tiếp.',
  'auth.mustSetup2fa':
    'Vai trò của bạn bắt buộc bật xác thực hai bước. Hãy thiết lập trước khi dùng các màn hình khác.',

  // ── Độ mạnh mật khẩu ─────────────────────────────────────
  'password.strength': 'Độ mạnh',
  'password.strength.0': 'Rất yếu',
  'password.strength.1': 'Yếu',
  'password.strength.2': 'Trung bình',
  'password.strength.3': 'Mạnh',
  'password.strength.4': 'Rất mạnh',
  'password.hint': 'Tối thiểu 12 ký tự, có chữ hoa, chữ thường và chữ số.',

  // ── Tổng quan ────────────────────────────────────────────
  'overview.title': 'Tổng quan',
  'overview.greeting': 'Chào {name}',
  'overview.ledeAdmin':
    'Bạn đang xem toàn hệ thống: {domains} tên miền, kèm cài đặt và nhật ký quản trị.',
  'overview.ledeUser':
    'Bạn đang xem phạm vi cá nhân: {domains} tên miền do bạn thêm hoặc được cấp quyền.',
  'overview.stat.domains': 'Tên miền',
  'overview.stat.domainsSub': 'Trong phạm vi của bạn',
  'overview.stat.records': 'Bản ghi DNS',
  'overview.stat.recordsSub': 'Trên các tên miền bạn thấy',
  'overview.stat.attention': 'Cần chú ý',
  'overview.stat.attentionSub': 'Chờ nameserver hoặc đang lỗi',
  'overview.stat.connections': 'Kết nối Cloudflare',
  'overview.stat.connectionsSub': 'Đang hoạt động',
  'overview.recent.title': 'Tên miền mới cập nhật',
  'overview.recent.sub': 'Năm tên miền thay đổi gần nhất',
  'overview.recent.all': 'Xem tất cả',
  'overview.alerts.title': 'Việc cần làm',
  'overview.alerts.sub': 'Ưu tiên theo mức rủi ro',
  'overview.alerts.empty': 'Không có việc nào cần xử lý',
  'overview.activity.title': 'Hoạt động gần đây',
  'overview.activity.empty': 'Chưa có hoạt động nào',
  'overview.alert.ns_pending.when': 'Cần theo dõi',
  'overview.alert.ns_pending.title': '{count} tên miền chưa trỏ nameserver',
  'overview.alert.ns_pending.body': 'Vùng DNS đã tạo nhưng chưa nhận lưu lượng.',
  'overview.alert.ssl_expiring.when': 'Sắp tới',
  'overview.alert.ssl_expiring.title': '{count} chứng chỉ SSL hết hạn dưới 15 ngày',
  'overview.alert.ssl_expiring.body': 'Kiểm tra lại cấu hình SSL/TLS của vùng.',
  'overview.alert.connection_invalid.when': 'Rủi ro cao',
  'overview.alert.connection_invalid.title': '{count} kết nối Cloudflare lỗi xác thực',
  'overview.alert.connection_invalid.body': 'Token bị thu hồi hoặc thiếu quyền.',
  'overview.alert.twofa_missing.when': 'Chính sách',
  'overview.alert.twofa_missing.title': '{count} tài khoản chưa bật 2FA',
  'overview.alert.twofa_missing.body': 'Chính sách hệ thống đang yêu cầu bắt buộc 2FA.',
  'overview.start.title': 'Bắt đầu trong ba bước',
  'overview.start.sub': 'Từ khi thêm token tới khi mời cộng tác viên',
  'overview.start.step1': 'Thêm kết nối Cloudflare',
  'overview.start.step1Body': 'Dán API Token của bạn; hệ thống xác thực trước khi lưu.',
  'overview.start.step2': 'Thêm tên miền',
  'overview.start.step2Body': 'Vùng DNS được tạo trên Cloudflare, sau đó trỏ nameserver.',
  'overview.start.step3': 'Mời cộng tác viên',
  'overview.start.step3Body': 'Chia sẻ một tên miền theo email, không cần mở cả tài khoản.',
  'overview.yourRole': 'Vai trò của bạn',
  'overview.capabilities': 'Quyền hệ thống',
  'overview.capabilityCount': '{count} quyền hệ thống',
  'overview.security': 'Bảo mật tài khoản',
  'overview.twofaOn': 'Đã bật xác thực hai bước',
  'overview.twofaOff': 'Chưa bật xác thực hai bước',
  'overview.setup2fa': 'Bật ngay',
  'overview.lastLogin': 'Đăng nhập gần nhất',
  'overview.quickLinks': 'Lối tắt',

  // ── Tìm kiếm toàn cục (FR-005) ───────────────────────────
  'search.empty': 'Không tìm thấy kết quả nào',
  'search.group.domains': 'Tên miền',
  'search.group.records': 'Bản ghi DNS',
  'search.group.users': 'Người dùng',
  'search.usersAdminOnly': 'Chỉ quản trị viên mới tìm được người dùng.',

  // ── Hồ sơ ────────────────────────────────────────────────
  'profile.title': 'Hồ sơ & bảo mật',
  'profile.lede':
    'Thông tin cá nhân, mật khẩu, xác minh hai bước và các phiên đăng nhập của riêng bạn.',
  'profile.tab.info': 'Thông tin cá nhân',
  'profile.tab.security': 'Mật khẩu & 2FA',
  'profile.tab.sessions': 'Phiên & thiết bị',
  'profile.tab.prefs': 'Thông báo',

  'profile.info.heading': 'Hồ sơ',
  'profile.info.avatar': 'Ảnh đại diện',
  'profile.info.avatarHint': 'PNG, JPG hoặc WebP, tối đa 2 MB.',
  'profile.info.avatarUpload': 'Đổi ảnh đại diện',
  'profile.info.fullName': 'Họ và tên',
  'profile.info.email': 'Email',
  'profile.info.emailLogin': 'Email đăng nhập',
  'profile.info.emailHint': 'Đổi email cần xác minh qua liên kết gửi tới hộp thư mới.',
  'profile.info.phone': 'Số điện thoại',
  'profile.info.timezone': 'Múi giờ',
  'profile.info.locale': 'Ngôn ngữ',
  'profile.info.changeEmail': 'Đổi email',
  'profile.info.newEmail': 'Email mới',
  'profile.info.currentPasswordToConfirm': 'Xác nhận bằng mật khẩu',
  'profile.info.emailSent':
    'Đã gửi thư xác minh tới địa chỉ mới. Email chỉ đổi sau khi bạn xác minh.',
  'profile.info.saved': 'Đã lưu hồ sơ cá nhân.',

  'profile.account.heading': 'Tài khoản',
  'profile.account.role': 'Vai trò',
  'profile.account.email': 'Email',
  'profile.account.joined': 'Tham gia',
  'profile.account.domains': 'Tên miền quản lý',
  'profile.account.timezone': 'Múi giờ',

  'profile.score.heading': 'Điểm bảo mật',
  'profile.score.met': '{met} / {total} khuyến nghị đã đạt',
  'profile.score.level.ok': 'Tốt',
  'profile.score.level.warn': 'Khá',
  'profile.score.level.bad': 'Yếu',
  'profile.score.todo': 'chưa đạt',
  'profile.score.password_fresh': 'Mật khẩu được đổi gần đây',
  'profile.score.twofa_enabled': 'Xác minh hai bước bằng TOTP',
  'profile.score.recovery_codes': 'Còn mã khôi phục dùng được',
  'profile.score.email_verified': 'Email đã xác minh',
  'profile.score.passkey_added': 'Đã có passkey để đăng nhập',

  'profile.password.heading': 'Đổi mật khẩu',
  'profile.password.sub': 'Đổi xong, mọi phiên khác sẽ bị kết thúc.',
  'profile.password.current': 'Mật khẩu hiện tại',
  'profile.password.new': 'Mật khẩu mới',
  'profile.password.confirm': 'Nhập lại mật khẩu mới',
  'profile.password.submit': 'Cập nhật mật khẩu',
  'profile.password.signOutOthers': 'Đăng xuất mọi thiết bị khác',
  'profile.password.signOutOthersSub': 'Luôn bật để bảo vệ tài khoản sau khi đổi mật khẩu.',
  'profile.password.done': 'Đã đổi mật khẩu. Các phiên khác đã bị đăng xuất.',
  'profile.password.doneTitle': 'Đổi mật khẩu thành công',
  'profile.password.doneMessage':
    'Mật khẩu đã được đổi thành công. Vui lòng đăng nhập lại bằng mật khẩu mới.',
  'profile.password.doneNote':
    'Khi bạn bấm Đồng ý, mọi phiên đăng nhập trên tất cả thiết bị sẽ bị kết thúc và bạn được đưa về trang đăng nhập.',
  'common.agree': 'Đồng ý',

  'profile.2fa.heading': 'Xác minh hai bước',
  'profile.2fa.sub': 'Lớp bảo vệ thứ hai khi đăng nhập',
  'profile.2fa.chipOn': '2FA đang bật',
  'profile.2fa.chipOff': '2FA đang tắt',
  'profile.2fa.totp': 'Ứng dụng xác thực (TOTP)',
  'profile.2fa.setupOn': 'Thiết lập {date}',
  'profile.2fa.notSet': 'Chưa thiết lập ứng dụng xác thực.',
  'profile.2fa.enable': 'Thiết lập',
  'profile.2fa.reconfigure': 'Thiết lập lại',
  'profile.2fa.off': 'Tắt',
  'profile.2fa.keep': 'Giữ 2FA',
  'profile.2fa.disable': 'Tắt xác minh hai bước',
  'profile.2fa.setupTitle': 'Thiết lập xác minh hai bước',
  'profile.2fa.setupStep1': 'Quét mã bằng Google Authenticator, 1Password hoặc Authy',
  'profile.2fa.setupStep2': 'Không quét được? Nhập khoá thủ công',
  'profile.2fa.setupStep3': 'Nhập mã 6 số từ ứng dụng',
  'profile.2fa.recoveryNote':
    'Sau khi bật, bạn sẽ nhận 10 mã khôi phục. Hãy lưu chúng ở nơi an toàn — mỗi mã chỉ dùng được một lần.',
  'profile.2fa.confirm': 'Xác nhận & bật 2FA',
  'profile.2fa.enabled': 'Đã bật xác minh hai bước.',
  'profile.2fa.disabled': 'Đã tắt xác minh hai bước.',
  'profile.2fa.disableTitle': 'Tắt xác minh hai bước',
  'profile.2fa.disableWarn': 'Tài khoản sẽ chỉ còn được bảo vệ bằng mật khẩu.',
  'profile.2fa.currentCode': 'Mã xác thực hiện tại',

  'profile.recovery.heading': 'Mã khôi phục',
  'profile.recovery.sub': 'Dùng khi bạn mất thiết bị xác thực',
  'profile.recovery.remaining': 'Còn {remaining} / {total} mã',
  'profile.recovery.none': 'Chưa có mã',
  'profile.recovery.hidden':
    'Mã chỉ hiện đúng một lần lúc tạo. Nếu đã mất, hãy tạo bộ mã mới — bộ cũ sẽ hết hiệu lực.',
  'profile.recovery.need2fa':
    'Mã khôi phục dùng khi bạn mất thiết bị xác thực, nên chỉ có ý nghĩa sau khi bật xác minh hai bước. Hãy thiết lập ứng dụng xác thực trước.',
  'profile.recovery.regenerate': 'Tạo bộ mã mới',
  'profile.recovery.saved': 'Tôi đã lưu các mã này ở nơi an toàn',
  'profile.recovery.warn': 'Các mã chỉ hiện đúng một lần. Hãy lưu lại ngay.',
  'profile.recovery.done': 'Đã tạo 10 mã khôi phục mới. Các mã cũ không còn dùng được.',

  'profile.sessions.heading': 'Phiên đăng nhập',
  'profile.sessions.sub': 'Các thiết bị đang đăng nhập vào tài khoản của bạn.',
  'profile.sessions.device': 'Thiết bị',
  'profile.sessions.location': 'Vị trí (ước lượng)',
  'profile.sessions.ip': 'Địa chỉ IP',
  'profile.sessions.lastSeen': 'Hoạt động gần nhất',
  'profile.sessions.actions': 'Thao tác',
  'profile.sessions.other': 'Phiên khác',
  'profile.sessions.locThisMachine': 'Máy này',
  'profile.sessions.locLan': 'Mạng nội bộ',
  'profile.sessions.locUnknown': 'Chưa tra được',
  'profile.sessions.ipLoopback': 'máy này',
  'profile.sessions.current': 'Phiên hiện tại',
  'profile.sessions.thisDevice': 'Thiết bị này',
  'profile.sessions.active': 'Đang hoạt động',
  'profile.sessions.trusted': 'Đã tin cho 2FA',
  'profile.sessions.end': 'Đăng xuất',
  'profile.sessions.endOthers': 'Đăng xuất mọi thiết bị khác',
  'profile.sessions.ended': 'Đã kết thúc phiên.',
  'profile.sessions.endedOthers': 'Đã kết thúc {count} phiên khác.',
  'profile.sessions.expiryNote': 'Phiên tự hết hạn khi không hoạt động quá thời hạn cấu hình.',

  'profile.securityLog.heading': 'Nhật ký bảo mật',
  'profile.securityLog.sub': '20 sự kiện gần nhất liên quan tới tài khoản của bạn.',
  'profile.securityLog.action': 'Hành động',

  'profile.prefs.heading': 'Nhận thông báo qua email',
  'profile.prefs.sub': 'Chỉ áp dụng cho tài khoản của bạn.',
  'profile.prefs.domain_shared': 'Có tên miền được chia sẻ cho tôi',
  'profile.prefs.domain_shared.sub': 'Gửi khi ai đó cấp cho bạn quyền trên một tên miền.',
  'profile.prefs.security_alerts': 'Cảnh báo bảo mật',
  'profile.prefs.security_alerts.sub': 'Đổi mật khẩu, bật/tắt 2FA, hoạt động bất thường.',
  'profile.prefs.new_device': 'Đăng nhập từ thiết bị mới',
  'profile.prefs.new_device.sub': 'Không thể tắt vì lý do bảo mật.',

  // ── Vai trò hệ thống ─────────────────────────────────────
  'roles.title': 'Quản lý quyền người dùng',
  'roles.lede':
    'Định nghĩa các loại quyền trong hệ thống. Mỗi tài khoản mang một vai trò hệ thống; quyền trên bản ghi DNS của từng tên miền được định nghĩa ở màn hình Quản lý quyền tên miền.',
  'roles.listTitle': 'Loại quyền',
  'roles.count': '{count} vai trò',
  'roles.add': 'Thêm loại quyền',
  'roles.addNew': 'Thêm loại quyền mới',
  'roles.assignedTo': 'Đang gán cho',
  'roles.userCount': '{count} người dùng',
  'roles.noUser': 'Chưa có người dùng nào',
  'roles.systemNote': 'Vai trò hệ thống không sửa và không xoá được; luôn giữ toàn bộ năng lực.',
  'roles.defaultNote': 'Vai trò mặc định được gán cho mọi tài khoản mới.',
  'roles.footNote': 'Thay đổi áp dụng cho mọi tài khoản mang vai trò này và được ghi vào nhật ký.',
  'roles.reset': 'Khôi phục mặc định',
  'roles.saveRole': 'Lưu vai trò',
  'roles.name': 'Tên vai trò',
  'roles.description': 'Mô tả',
  'roles.setDefault': 'Đặt làm vai trò mặc định cho người dùng mới',
  'roles.deleteTitle': 'Xoá vai trò',
  'roles.deleteBody': 'Vai trò "{name}" sẽ bị xoá vĩnh viễn.',
  'roles.deleteInUse':
    'Vai trò này đang có {count} người dùng. Hãy chọn vai trò chuyển tiếp cho họ.',
  'roles.fallbackRole': 'Vai trò chuyển tiếp',
  'roles.created': 'Đã tạo vai trò "{name}".',
  'roles.updated': 'Đã lưu vai trò "{name}".',
  'roles.duplicated': 'Đã nhân bản thành "{name}".',
  'roles.deleted': 'Đã xoá vai trò.',
  'roles.wasReset': 'Đã khôi phục capability mặc định.',
  'roles.capabilities': 'Năng lực',
  'roles.matrixTitle': 'So sánh nhanh',
  'roles.matrixSub': 'Ma trận năng lực của tất cả loại quyền hiện có.',
  'roles.capabilityCount': '{on}/{total}',

  // ── Mức quyền tên miền ───────────────────────────────────
  'domainRoles.title': 'Quản lý quyền tên miền',
  'domainRoles.lede':
    'Định nghĩa những gì một người làm được trên một tên miền cụ thể. Mức quyền được gán qua màn hình Phân quyền tên miền.',
  'domainRoles.listTitle': 'Mức quyền',
  'domainRoles.count': '{count} mức quyền',
  'domainRoles.add': 'Thêm mức quyền',
  'domainRoles.grantCount': '{count} lượt cấp',
  'domainRoles.level': 'Mức độ',
  'domainRoles.systemNote':
    'Mức Chủ sở hữu sinh tự động khi thêm tên miền hoặc chuyển quyền sở hữu; không sửa và không xoá được.',
  'domainRoles.affected':
    'Thay đổi này ảnh hưởng ngay tới {count} lượt cấp quyền đang dùng mức này.',
  'domainRoles.matrixTitle': 'So sánh nhanh',
  'domainRoles.matrixSub': 'Ma trận năng lực của tất cả mức quyền hiện có.',
  'domainRoles.deleteTitle': 'Xoá mức quyền',
  'domainRoles.deleteInUse': 'Mức quyền này đang được cấp {count} lượt. Hãy chọn mức thay thế.',
  'domainRoles.fallbackRole': 'Mức quyền thay thế',
  'domainRoles.created': 'Đã tạo mức quyền "{name}".',
  'domainRoles.updated': 'Đã lưu mức quyền "{name}".',
  'domainRoles.deleted': 'Đã xoá mức quyền.',

  // ── Nhật ký hành động (nhãn) ─────────────────────────────
  'action.auth.login': 'Đăng nhập',
  'action.auth.login_failed': 'Đăng nhập thất bại',
  'action.auth.logout': 'Đăng xuất',
  'action.auth.new_device': 'Đăng nhập từ thiết bị mới',
  'action.auth.password_reset': 'Đặt lại mật khẩu',
  'action.auth.2fa_enabled': 'Bật xác thực hai bước',
  'action.auth.2fa_disabled': 'Tắt xác thực hai bước',
  'action.auth.recovery_used': 'Dùng mã khôi phục',
  'action.auth.passkey_added': 'Thêm passkey',
  'action.auth.passkey_removed': 'Gỡ passkey',
  'action.auth.passkey_login': 'Đăng nhập bằng passkey',
  'action.user.update': 'Cập nhật tài khoản',
  'action.user.role_change': 'Đổi vai trò',
  'action.user.suspend': 'Tạm ngưng tài khoản',
  'action.user.force_2fa': 'Bắt buộc bật 2FA',
  'action.user.sessions_revoked': 'Kết thúc phiên đăng nhập',
  'action.grant.create': 'Cấp quyền tên miền',
  'action.grant.update': 'Đổi mức quyền',
  'action.grant.revoke': 'Thu hồi quyền',
  'action.grant.invite': 'Mời cấp quyền tên miền',
  'action.backup.remote_add': 'Thêm kho sao lưu ngoài',
  'action.backup.remote_update': 'Sửa kho sao lưu ngoài',
  'action.backup.remote_connect': 'Kết nối kho sao lưu ngoài',
  'action.backup.remote_check': 'Kiểm tra kho sao lưu ngoài',
  'action.backup.remote_remove': 'Xoá kho sao lưu ngoài',

  /* OQ-337 — Cloudflare Tunnel. */
  'action.tunnel.create': 'Tạo tunnel',
  'action.tunnel.delete': 'Xoá tunnel',
  'action.tunnel.token_view': 'Xem token cài đặt tunnel',
  'action.tunnel.config_update': 'Sửa cấu hình tunnel',
  'action.subdomain.create': 'Tạo tên miền con',
  'action.subdomain.delete': 'Xoá tên miền con',
  'action.subdomain.grant': 'Chia sẻ tên miền con',
  'action.subdomain.grant_update': 'Đổi mức quyền tên miền con',
  'action.subdomain.revoke': 'Thu hồi quyền tên miền con',
  'action.user.invite': 'Mời người dùng',
  'action.user.create': 'Tạo tài khoản',
  'action.user.delete': 'Xoá tài khoản',
  'action.domain.create': 'Thêm tên miền',
  'action.domain.update': 'Sửa tên miền',
  'action.domain.delete': 'Xoá tên miền',
  'action.domain.sync': 'Đồng bộ tên miền',
  'action.domain.transfer': 'Chuyển quyền sở hữu',
  'action.domain.pause': 'Tạm dừng tên miền',
  'action.domain.purge_cache': 'Xoá cache',
  'action.domain.ns_verify': 'Xác minh nameserver',
  'action.dns.create': 'Thêm bản ghi DNS',
  'action.dns.update': 'Sửa bản ghi DNS',
  'action.dns.delete': 'Xoá bản ghi DNS',
  'action.dns.proxy_toggle': 'Bật/tắt proxy Cloudflare',
  'action.dns.import': 'Nhập zone file',
  'action.dns.export': 'Xuất zone file',
  'action.dns.sync_removed': 'Gỡ bản ghi khi đồng bộ',
  'action.role.create': 'Tạo vai trò hệ thống',
  'action.role.update': 'Sửa vai trò hệ thống',
  'action.role.delete': 'Xoá vai trò hệ thống',
  'action.role.reset': 'Khôi phục vai trò mặc định',
  'action.domainrole.create': 'Tạo mức quyền tên miền',
  'action.domainrole.update': 'Sửa mức quyền tên miền',
  'action.domainrole.delete': 'Xoá mức quyền tên miền',
  'action.connection.create': 'Thêm kết nối Cloudflare',
  'action.connection.update': 'Sửa kết nối Cloudflare',
  'action.connection.verify': 'Kiểm tra token Cloudflare',
  'action.connection.rotate': 'Thay token Cloudflare',
  'action.connection.set_default': 'Đặt kết nối mặc định',
  'action.connection.pause': 'Tạm dừng kết nối',
  'action.connection.delete': 'Xoá kết nối Cloudflare',
  'action.setting.update': 'Đổi cài đặt hệ thống',
  'action.setting.smtp_test': 'Gửi thư kiểm tra SMTP',
  'result.success': 'Thành công',
  'result.failure': 'Thất bại',
  // ── Phân quyền tên miền — permissions.html (FR-070…085) ──
  'perm.title': 'Phân quyền tên miền',
  'perm.ledeAdmin':
    'Mặc định mỗi tên miền chỉ hiển thị với người đã thêm nó. Xem từ phía người dùng hoặc từ phía tên miền, rồi cấp — thu hồi quyền ngay tại đó.',
  'perm.ledeUser':
    'Chia sẻ những tên miền bạn đã thêm cho đồng nghiệp. Chọn một tên miền để xem ai đang truy cập, rồi cấp hoặc thu hồi quyền.',
  'perm.manageDomainRoles': 'Quản lý quyền tên miền',
  'perm.userScopeNote':
    'Bạn chỉ phân quyền được cho những tên miền chính bạn đã thêm. Tên miền được người khác chia sẻ cho bạn không xuất hiện ở đây.',
  'perm.tab.byUser': 'Theo người dùng',
  'perm.tab.byDomain': 'Theo tên miền',

  'perm.users': 'Người dùng',
  'perm.domains': 'Tên miền',
  'perm.filterUsers': 'Lọc người dùng…',
  'perm.filterDomains': 'Lọc tên miền…',
  'perm.noUserMatch': 'Không có người dùng khớp bộ lọc.',
  'perm.noDomainMatch': 'Không có tên miền khớp bộ lọc.',
  'perm.noDomainOwned': 'Bạn chưa thêm tên miền nào để phân quyền.',
  'perm.domainsSeen': 'tên miền được thấy',
  'perm.membersCount': 'người được truy cập',
  'perm.recordsCount': '{count} bản ghi',
  'perm.ownedBy': 'Của {name}',
  'perm.addedByYou': 'Bạn đã thêm',

  'perm.col.domain': 'Tên miền',
  'perm.col.user': 'Người dùng',
  'perm.col.relation': 'Quan hệ',
  'perm.col.level': 'Mức quyền',
  'perm.col.grantedAt': 'Cấp lúc',
  'perm.col.actions': 'Thao tác',
  'perm.relation.owned': 'Người thêm',
  'perm.relation.granted': 'Được cấp',
  'perm.relation.viewall': 'Toàn quyền hệ thống',
  'perm.ownerLevel': 'Chủ sở hữu',
  'perm.notRevocable': 'Không thu hồi được',
  'perm.grantedWhenAdded': 'Khi thêm tên miền',
  'perm.grantedBy': 'bởi {name}',
  'perm.revoke': 'Thu hồi',
  'perm.addDomain': 'Thêm tên miền',
  'perm.addUser': 'Thêm người dùng',

  'perm.userFootnote':
    'Chỉ những tên miền trong bảng này hiện ra khi người dùng đăng nhập. Thay đổi được ghi vào nhật ký.',
  'perm.emptyUserTitle': 'Người dùng này chưa thấy tên miền nào',
  'perm.emptyUserBody':
    'Họ chưa tự thêm tên miền và cũng chưa được cấp quyền. Dùng nút “Thêm tên miền” để gán tên miền đầu tiên.',
  'perm.emptyUserAction': 'Thêm tên miền cho người dùng này',
  'perm.emptyDomainTitle': 'Bạn chưa thêm tên miền nào',
  'perm.emptyDomainBody':
    'Chỉ tên miền do chính bạn thêm mới xuất hiện ở đây để chia sẻ cho người khác.',
  'perm.emptyNoUsers': 'Chưa có người dùng nào',

  // Hộp thoại "Thêm tên miền cho người dùng" (FR-073)
  'perm.addDomainTitle': 'Thêm tên miền cho người dùng',
  'perm.addDomainSub':
    'Cấp quyền cho {name}. Tên miền sẽ xuất hiện trong danh sách của họ ngay lập tức.',
  'perm.addDomainField': 'Tên miền chưa được gán',
  'perm.addDomainHint': '{count} tên miền chưa hiển thị với người dùng này.',
  'perm.addDomainNone': 'Người dùng này đã có quyền trên tất cả tên miền.',
  'perm.addDomainNoneOption': 'Không còn tên miền nào để cấp',
  'perm.grant': 'Cấp quyền',

  // Luồng thêm người dùng bằng email (FR-080…085)
  'perm.addUserTitle': 'Thêm người dùng cho tên miền',
  'perm.addUserSub': 'Cấp quyền trên {name}. Nhập email để tìm tài khoản.',
  'perm.shareTitle': 'Cấp quyền trên {name}',
  'perm.shareSub':
    'Nhập email của người bạn muốn thêm. Nếu chưa có tài khoản, chúng tôi sẽ gửi lời mời.',
  'perm.email': 'Email người dùng',
  'perm.emailPlaceholder': 'ten@congty.vn',
  'perm.lookup': 'Thêm',
  'perm.lookupHint': 'Hệ thống sẽ tìm tài khoản khớp email trước khi cấp quyền.',
  'perm.lookupInvalid': 'Nhập một địa chỉ email hợp lệ để tìm tài khoản.',
  'perm.lookupFound': 'Đã tìm thấy tài khoản trên hệ thống.',
  'perm.lookupMissing': 'Không tìm thấy tài khoản — hãy gửi lời mời.',
  'perm.lookupGranted': '{name} đã có quyền trên tên miền này. Hãy đổi mức quyền.',
  'perm.lookupTooMany': 'Bạn đã tra cứu quá nhiều lần. Hãy thử lại sau một phút.',
  'perm.changeEmail': 'Đổi email',
  'perm.notify': 'Gửi email thông báo',
  'perm.notifySub': 'Báo cho người dùng biết họ vừa được cấp quyền.',
  'perm.inviteWarn':
    'Chưa có tài khoản nào dùng {email}. Gửi lời mời tạo tài khoản — quyền bên dưới sẽ tự áp dụng ngay khi họ kích hoạt.',
  'perm.inviteName': 'Tên hiển thị (tuỳ chọn)',
  'perm.inviteNamePlaceholder': 'VD: Nguyễn Bảo Trân',
  'perm.inviteLevel': 'Mức quyền sẽ cấp sau khi kích hoạt',
  'perm.inviteMessage': 'Lời nhắn trong email mời',
  'perm.inviteMessageDefault': 'Chào bạn, mình mời bạn cùng quản lý DNS trên DNSHub.',
  'perm.inviteExpiry': 'Hạn dùng lời mời',
  'perm.inviteExpirySub': 'Liên kết kích hoạt hết hạn sau {days} ngày.',
  'perm.inviteDays': '{days} ngày',
  'perm.sendInvite': 'Gửi lời mời',
  'perm.pendingTitle': 'Lời mời chưa kích hoạt',
  'perm.pendingChip': 'Chờ kích hoạt',
  'perm.pendingResend': 'Gửi lại',
  'perm.inviteResent': 'Đã gửi lại lời mời tới {email}.',
  'perm.pendingRevoke': 'Huỷ lời mời',

  // Chuyển quyền sở hữu

  // Thông báo
  'perm.granted': 'Đã cấp {domain} cho {name}.',
  'perm.levelChanged': '{name} → {domain}: {level}.',
  'perm.revoked': 'Đã thu hồi quyền của {name} trên {domain}.',
  'perm.invited': 'Đã gửi lời mời tạo tài khoản tới {email}.',
  'perm.inviteRevoked': 'Đã huỷ lời mời tới {email}.',

  // ── Quyền truy cập trong chi tiết tên miền (dùng lại ở M4) ──
  'perm.accessGrantButton': 'Cấp quyền cho người dùng',
  'perm.accessSource': 'Nguồn',
  'perm.sourceOwner': 'Người thêm tên miền',
  'perm.sourceManual': 'Được cấp thủ công',
  'perm.sourceViewall': 'Quyền quản trị hệ thống',

  // ── Thông báo trong ứng dụng (M6) ────────────────────────
  'nav.notifications': 'Thông báo',
  'notifications.empty': 'Bạn chưa có thông báo nào.',
  'notifications.markAll': 'Đánh dấu đã đọc',

  // ── Người dùng · FR-050…056 ──────────────────────────────
  'users.title': 'Người dùng',
  'users.lede':
    'Tạo tài khoản, gán vai trò hệ thống và theo dõi trạng thái bảo mật. Quyền trên từng tên miền được cấu hình ở mục Phân quyền tên miền.',
  'users.export': 'Xuất CSV',
  'users.invite': 'Mời người dùng',
  'users.create': 'Tạo tài khoản',

  'users.createModal.title': 'Tạo tài khoản mới',
  'users.createModal.subtitle': 'Tài khoản dùng được ngay, không cần chờ người dùng bấm thư mời.',
  'users.createModal.email': 'Email',
  'users.createModal.fullName': 'Họ và tên',
  'users.createModal.role': 'Vai trò hệ thống',
  'users.createModal.submit': 'Tạo tài khoản',
  'users.createModal.doneTitle': 'Đã tạo tài khoản',
  'users.createModal.note':
    'Tài khoản được kích hoạt ngay và email coi như đã xác minh — bạn là người xác nhận địa chỉ thay cho vòng xác minh qua thư.',

  'users.resetModal.title': 'Đặt lại mật khẩu',
  'users.resetModal.submit': 'Đặt mật khẩu mới',
  'users.resetModal.doneTitle': 'Đã đặt lại mật khẩu',
  'users.resetModal.note':
    'Mọi phiên đang mở của người dùng sẽ bị thu hồi. Họ phải đăng nhập lại bằng mật khẩu mới.',

  'users.password.label': 'Mật khẩu mới',
  'users.password.placeholder': 'Để trống — hệ thống sẽ tự sinh',
  'users.password.generate': 'Sinh mật khẩu',
  'users.password.show': 'Hiện mật khẩu',
  'users.password.hide': 'Ẩn mật khẩu',
  'users.password.hint': 'Bấm vào ô để tự đặt, hoặc để trống cho hệ thống sinh ngẫu nhiên.',
  'users.password.mustChange': 'Yêu cầu người dùng đổi mật khẩu ở lần đăng nhập kế tiếp',
  'users.password.mustChangeNote':
    'Người dùng sẽ được đưa tới màn đổi mật khẩu ngay sau khi đăng nhập.',
  'users.password.success': 'Đã đổi mật khẩu cho {email} thành công.',
  'users.password.createdSuccess': 'Đã tạo tài khoản {email} thành công.',
  'users.password.newPassword': 'Mật khẩu mới',
  'users.password.onceOnly': 'Mật khẩu chỉ hiện một lần. Hãy chép lại trước khi đóng cửa sổ này.',
  'users.password.copied': 'Đã chép',
  'users.password.copyFailed': 'Không chép được — hãy bôi đen rồi chép tay.',
  'users.password.linkSent':
    'Đã gửi thêm liên kết đặt lại mật khẩu vào email của người dùng, hết hạn sau {hours} giờ hoặc ngay khi họ đăng nhập bằng mật khẩu trên.',
  'users.password.linkFailed':
    'Không gửi được email — mật khẩu đã đổi thành công, hãy chuyển mật khẩu trên cho người dùng.',

  'users.detail.resetPassword': 'Đặt lại mật khẩu',
  'users.stat.active': 'Tài khoản hoạt động',
  'users.stat.activeSub': 'Trên tổng {total} tài khoản',
  'users.stat.twofa': 'Đã bật 2FA',
  'users.stat.twofaSub': '{percent}% — mục tiêu 100%',
  'users.stat.invited': 'Chờ xác nhận lời mời',
  'users.stat.invitedSub': 'Không có lời mời quá hạn',
  'users.stat.invitedExpired': 'lời mời đã quá hạn',
  'users.stat.suspended': 'Đã tạm ngưng',
  'users.stat.suspendedSub': 'Do quản trị viên vô hiệu hoá',
  'users.stat.locked': 'Bị khoá',
  'users.stat.lockedSub': 'Do vượt ngưỡng đăng nhập sai',
  'users.filter.all': 'Tất cả',
  'users.filter.admin': 'Quản trị',
  'users.filter.member': 'Thành viên',
  'users.filter.invited': 'Chờ xác nhận',
  'users.filter.suspended': 'Tạm ngưng',
  'users.filter.locked': 'Bị khoá',
  'users.searchPlaceholder': 'Tìm tên hoặc email…',
  'users.searchAria': 'Tìm người dùng',
  'users.selectAll': 'Chọn tất cả',
  'users.selectOne': 'Chọn {name}',
  'users.col.user': 'Người dùng',
  'users.col.name': 'Họ và tên',
  'users.col.role': 'Vai trò hệ thống',
  'users.col.domains': 'Tên miền',
  'users.col.twofa': '2FA',
  'users.col.lastLogin': 'Đăng nhập gần nhất',
  'users.col.status': 'Trạng thái',
  'users.col.actions': 'Thao tác',
  'users.status.active': 'Hoạt động',
  'users.status.invited': 'Chờ xác nhận',
  'users.status.suspended': 'Đã tạm ngưng',
  'users.status.locked': 'Bị khoá',
  'users.twofa.required': 'Buộc bật',
  'users.twofa.off': 'Chưa bật',
  'users.twofa.none': 'Chưa thiết lập',
  'users.neverLogin': 'Chưa đăng nhập',
  'users.action.self': 'Chính bạn',
  'users.action.resend': 'Gửi lại',
  'users.action.revoke': 'Thu hồi',
  'users.action.unlock': 'Mở khoá',
  'users.action.permissions': 'Phân quyền',
  'users.action.detail': 'Chi tiết',
  'users.action.remind2fa': 'Nhắc 2FA',
  'users.foot.selected': 'Đã chọn {count} người dùng',
  'users.bulk.force2fa': 'Yêu cầu bật 2FA',
  'users.bulk.suspend': 'Vô hiệu hoá',
  'users.bulk.activate': 'Kích hoạt lại',
  'users.bulk.activateHint': 'Mở lại {count} tài khoản đang bị vô hiệu hoặc bị khoá.',
  'users.bulk.suspendHint': 'Vô hiệu hoá {count} tài khoản đang hoạt động.',
  'users.empty.title': 'Chưa có người dùng nào',
  'users.empty.body': 'Hãy mời người đầu tiên vào hệ thống.',
  'users.empty.filter': 'Không có người dùng nào khớp bộ lọc',
  'users.empty.filterBody': 'Thử bỏ bớt bộ lọc hoặc đổi từ khoá tìm kiếm.',
  'users.toast.exported': 'Đã xuất danh sách người dùng (CSV).',
  'users.toast.invited': 'Đã gửi lời mời tới {email}.',
  'users.toast.resent': 'Đã gửi lại lời mời tới {email}.',
  'users.toast.force2fa': 'Đã yêu cầu bật 2FA ở lần đăng nhập tới.',
  'users.toast.unlocked': 'Đã mở khoá tài khoản.',
  'users.toast.suspendedMany': 'Đã tạm ngưng {count} tài khoản.',
  'users.toast.activatedMany': 'Đã kích hoạt lại {count} tài khoản.',
  'users.toast.deleted': 'Đã xoá tài khoản.',
  'users.toast.saved': 'Đã lưu thay đổi.',
  'users.toast.resetSent': 'Đã gửi liên kết đặt lại mật khẩu.',
  'users.toast.sessionsRevoked': 'Đã kết thúc mọi phiên của người dùng.',
  'users.toast.twofaDisabled': 'Đã vô hiệu hoá 2FA — người dùng cần thiết lập lại.',
  'users.inviteModal.title': 'Mời người dùng',
  'users.inviteModal.subtitle':
    'Tài khoản được tạo ở trạng thái chờ xác nhận cho tới khi họ đặt mật khẩu.',
  'users.inviteModal.email': 'Email',
  'users.inviteModal.role': 'Vai trò hệ thống',
  'users.inviteModal.roleHint': 'Quản trị viên có toàn quyền trên mọi tên miền.',
  'users.inviteModal.expires': 'Hạn lời mời (ngày)',
  'users.inviteModal.message': 'Lời nhắn',
  'users.inviteModal.submit': 'Gửi lời mời',
  'users.inviteModal.note':
    'Quyền trên từng tên miền được cấp riêng ở màn Phân quyền tên miền, không kèm trong lời mời.',
  'users.detail.title': 'Chi tiết người dùng',
  'users.detail.joined': 'tham gia {date}',
  'users.detail.security': 'Bảo mật',
  'users.detail.lastLogin': 'Đăng nhập gần nhất',
  'users.detail.sessions': 'Phiên đang mở',
  'users.detail.sessionCount': '{count} thiết bị',
  'users.detail.passwordChanged': 'Đổi mật khẩu',
  'users.detail.scope': 'Phạm vi tên miền',
  'users.detail.noDomain': 'Chưa sở hữu tên miền nào.',
  'users.detail.openPermissions': 'Mở bảng phân quyền',
  'users.detail.profile': 'Hồ sơ & vai trò',
  'users.detail.fullName': 'Họ và tên',
  'users.detail.phone': 'Số điện thoại',
  'users.detail.role': 'Vai trò hệ thống',
  'users.detail.selfRoleNote': 'Bạn không tự đổi được vai trò của chính mình.',
  'users.detail.adminActions': 'Hành động quản trị',
  'users.detail.sendReset': 'Gửi liên kết đổi mật khẩu',
  'users.detail.endSessions': 'Đăng xuất mọi phiên',
  'users.detail.reset2fa': 'Đặt lại 2FA',
  'users.detail.force2fa': 'Buộc bật 2FA',
  'users.detail.suspend': 'Vô hiệu hoá tài khoản',
  'users.detail.activate': 'Mở lại tài khoản',
  'users.detail.delete': 'Xoá tài khoản',
  'users.detail.foot': 'Mọi hành động đều được ghi vào nhật ký.',
  'users.deleteModal.title': 'Xoá người dùng',
  'users.deleteModal.subtitle': 'Tài khoản {email} sẽ không đăng nhập được nữa.',
  'users.deleteModal.ownsDomains':
    'Tài khoản này còn sở hữu {count} tên miền. Hãy chọn người nhận chuyển giao.',
  'users.deleteModal.transferTo': 'Chuyển tên miền cho',
  'users.deleteModal.confirmLabel': 'Gõ đúng email để xác nhận:',
  'users.deleteModal.submit': 'Xoá tài khoản',

  // ── Cài đặt hệ thống · FR-110…116 ────────────────────────
  'settings.title': 'Cài đặt hệ thống',
  'settings.lede':
    'Chính sách bảo mật, quy tắc thêm tên miền, thư hệ thống và thương hiệu áp dụng cho toàn bộ tổ chức. Token Cloudflare nằm ở',
  'settings.cloudflareLink': 'Quản lý kết nối Cloudflare',
  'settings.restoreDefaults': 'Khôi phục mặc định',
  /* OQ-330 — passkey */
  'auth.login.or': 'hoặc',
  'auth.login.passkey': 'Đăng nhập bằng passkey',
  'profile.passkey.title': 'Passkey',
  'profile.passkey.sub':
    'Đăng nhập bằng vân tay, khuôn mặt hoặc mã PIN của thiết bị — không cần nhớ mật khẩu và không cần nhập mã OTP.',
  'profile.passkey.empty': 'Bạn chưa có passkey nào.',
  'profile.passkey.add': 'Thêm passkey trên thiết bị này',
  'profile.passkey.added': 'Đã thêm passkey. Lần sau bạn có thể đăng nhập bằng nó.',
  'profile.passkey.removed': 'Đã gỡ passkey.',
  'profile.passkey.rename': 'Đổi tên',
  'profile.passkey.remove': 'Gỡ',
  'profile.passkey.neverUsed': 'Chưa dùng lần nào',
  'profile.passkey.col.name': 'Tên',
  'profile.passkey.col.created': 'Tạo lúc',
  'profile.passkey.col.lastUsed': 'Dùng gần nhất',
  'profile.passkey.unsupported':
    'Trình duyệt này không hỗ trợ passkey. Hãy dùng Chrome, Edge, Safari hoặc Firefox bản mới.',
  'settings.tab.security': 'Bảo mật',
  'settings.tab.sync': 'Đồng bộ',
  'settings.tab.policy': 'Chính sách tên miền',
  'settings.tab.smtp': 'SMTP',
  'settings.tab.mail': 'Mẫu thư',
  'settings.tab.branding': 'Thương hiệu',
  'settings.remote.title': 'Kho sao lưu ngoài máy chủ',
  'settings.remote.lede':
    'Bản sao lưu nằm trong máy chủ sẽ mất theo máy. Nối một hoặc nhiều kho để giữ bản sao ở nơi khác.',
  'settings.remote.provider': 'Nhà cung cấp',
  'settings.remote.add': 'Thêm kho',
  'settings.remote.added': 'Đã thêm kho. Bấm Kết nối để cấp quyền.',
  'settings.remote.connect': 'Kết nối',
  'settings.remote.connected': 'Đã kết nối kho sao lưu.',
  'settings.remote.notConnected': 'Chưa cấp quyền',
  'settings.remote.test': 'Kiểm tra kết nối',
  'settings.remote.testOk': 'Kết nối tốt · {n} bản trên kho',
  'settings.remote.remove': 'Xoá kết nối',
  'settings.remote.removeTitle': 'Xoá kết nối kho sao lưu?',
  'settings.remote.removeBody':
    'Gỡ kết nối tới {label}. Hệ thống sẽ ngừng đẩy bản sao lưu lên kho này.',
  'settings.remote.removeKeepsFiles':
    'Bản sao lưu đã đẩy lên vẫn còn nguyên trong tài khoản của bạn — xoá kết nối không xoá chúng.',
  'settings.remote.removed': 'Đã xoá kết nối.',
  'settings.remote.enabled': 'Đang bật',
  'settings.remote.disabled': 'Đang tắt',
  'settings.remote.enabledHint':
    'Kho này ĐANG nhận bản sao lưu: mỗi lượt sao lưu mới sẽ được đẩy lên đây. Bỏ chọn để tạm ngừng mà vẫn giữ kết nối.',
  'settings.remote.disabledHint':
    'Kho này ĐANG TẮT: kết nối vẫn còn nhưng không bản sao lưu mới nào được đẩy lên. Chọn lại để tiếp tục.',
  'settings.remote.pause': 'Tạm ngừng đẩy lên kho này',
  'settings.remote.resume': 'Bật lại kho này',
  'settings.remote.status.ok': 'Tốt',
  'settings.remote.status.invalid': 'Lỗi',
  'settings.remote.status.unchecked': 'Chưa kiểm tra',
  'settings.remote.emptyTitle': 'Chưa nối kho nào',
  'settings.remote.emptyBody':
    'Chọn nhà cung cấp rồi bấm Thêm kho. Có thể thêm nhiều tài khoản cùng lúc để dự phòng chéo.',
  'settings.remote.restoreFrom': 'Khôi phục từ cloud',
  'settings.remote.restoreTitle': 'Khôi phục từ {label}',
  'settings.remote.restored': 'Đã khôi phục từ kho ngoài.',
  'settings.remote.restoreWarn':
    'Khôi phục ghi đè dữ liệu hiện tại. Hệ thống tự tạo một bản an toàn trước khi ghi đè.',
  'settings.remote.noFilesTitle': 'Kho này chưa có bản sao lưu nào',
  'settings.remote.noFilesBody': 'Bản sao lưu sẽ xuất hiện ở đây sau lần chạy tiếp theo.',
  'setting.backup.oauth.dropbox.client_id': 'Dropbox · App key',
  'setting.backup.oauth.dropbox.client_secret': 'Dropbox · App secret',
  'setting.backup.oauth.gdrive.client_id': 'Google · Client ID',
  'setting.backup.oauth.gdrive.client_secret': 'Google · Client secret',
  'settings.oauthApp.show': 'Chưa có App key / Client ID? Xem hướng dẫn đăng ký (làm một lần)',
  'settings.oauthApp.hide': 'Ẩn hướng dẫn đăng ký ứng dụng',
  'settings.oauthApp.title': 'Đăng ký ứng dụng OAuth',
  'settings.oauthApp.once':
    'Chỉ làm MỘT LẦN cho cả hệ thống. Sau đó thêm bao nhiêu tài khoản cũng chỉ cần bấm Kết nối và đăng nhập.',
  'settings.oauthApp.redirectUri': 'Dán đúng địa chỉ này vào ô Redirect URI của nhà cung cấp:',
  'settings.oauthApp.thenConnect':
    'Xong bước này thì quay lại đây, dán App key / Client ID vào ô bên dưới, lưu thay đổi, rồi bấm Kết nối ở từng kho.',
  'settings.oauthApp.dropbox1':
    'Mở Dropbox App Console → **Create app** → chọn *Scoped access* → *App folder* → đặt tên.',
  'settings.oauthApp.dropbox2':
    'Tab **Permissions**: tick files.content.write, files.content.read và account_info.read → **Submit**.',
  'settings.oauthApp.dropbox3':
    'Tab **Settings**, mục OAuth 2 → Redirect URIs: dán địa chỉ ở trên rồi bấm **Add**.',
  'settings.oauthApp.dropbox4': 'Vẫn ở tab Settings: chép **App key** và **App secret**.',
  'settings.oauthApp.gdrive1':
    'Mở Google Cloud Console → tạo project → bật **Google Drive API** trong APIs & Services → Library.',
  'settings.oauthApp.gdrive2':
    'Vào OAuth consent screen: chọn **External**, điền tên và email, thêm chính bạn vào **Test users**.',
  'settings.oauthApp.gdrive3':
    'Vào Credentials → **Create credentials → OAuth client ID** → loại **Web application**, dán địa chỉ ở trên vào **Authorized redirect URIs**.',
  'settings.oauthApp.gdrive4': 'Chép **Client ID** và **Client secret** vừa hiện ra.',
  /* OQ-327 — tab Mẫu thư */
  'settings.mail.lede':
    'Sửa tiêu đề và nội dung thư cho từng luồng. Hệ thống tự bọc logo, màu sắc và chân trang — bạn chỉ cần lo lời lẽ.',
  'settings.mail.listTitle': 'Các luồng gửi thư',
  'settings.mail.listSub': '{count} luồng',
  'settings.mail.col.flow': 'Luồng',
  'settings.mail.col.state': 'Trạng thái',
  'settings.mail.state.custom': 'Đã tuỳ biến',
  'settings.mail.state.default': 'Mặc định',
  'settings.mail.pickTitle': 'Chọn một luồng',
  'settings.mail.pickSub': 'Bấm vào tên luồng ở danh sách bên trái.',
  'settings.mail.pickHint': 'Chưa chọn luồng nào để sửa.',
  'settings.mail.subject': 'Tiêu đề thư',
  'settings.mail.body': 'Nội dung thư',
  'settings.mail.bodyHint':
    'Gõ như gõ tin nhắn. Để một dòng trống để ngăn đoạn. Không dùng HTML — mọi thẻ sẽ hiện nguyên văn.',
  'settings.mail.vars': 'Biến dùng được',
  'settings.mail.varsHint':
    'Gõ đúng tên trong ngoặc nhọn, hệ thống sẽ thay bằng giá trị thật. Biến không có trong danh sách sẽ bị từ chối khi lưu.',
  'settings.mail.noVars': 'Luồng này không có biến nào.',
  'settings.mail.varTip': '{moTa} — ví dụ: {viDu}',
  'settings.mail.save': 'Lưu mẫu này',
  'settings.mail.preview': 'Xem trước',
  'settings.mail.previewTitle': 'Thư sẽ trông như thế này',
  'settings.mail.restore': 'Khôi phục mặc định',
  'settings.mail.saveNote':
    'Nút "Lưu thay đổi" ở đầu trang không lưu mẫu thư — mỗi mẫu lưu riêng bằng nút ở trên.',
  'settings.mail.saved': 'Đã lưu mẫu thư. Thư gửi sau đây sẽ dùng nội dung mới.',
  'settings.mail.restored': 'Đã khôi phục mẫu về nội dung mặc định.',
  /* OQ-333 — dọn nhật ký cũ */
  'settings.auditArchive.title': 'Dọn nhật ký cũ',
  'settings.auditArchive.sub': 'Đưa nhật ký cũ ra tệp rồi xoá khỏi cơ sở dữ liệu.',
  'settings.auditArchive.lede':
    'Nhật ký chỉ ghi thêm, không tự xoá bao giờ. Khi bảng lớn dần, bạn có thể đưa phần cũ ra tệp — hệ thống ghi tệp, đọc lại kiểm đủ dòng, rồi mới xoá. Nếu tệp xuất ra thiếu dòng thì không dòng nào bị xoá.',
  'settings.auditArchive.before': 'Đưa ra tệp phần cũ hơn ngày',
  'settings.auditArchive.beforeHint':
    'Nhật ký phải giữ ít nhất 365 ngày, nên không chọn được mốc gần hơn.',
  'settings.auditArchive.count': 'Sẽ đưa ra tệp và xoá khỏi cơ sở dữ liệu: {soDong} dòng.',
  'settings.auditArchive.run': 'Đưa ra tệp rồi xoá',
  'settings.auditArchive.confirmTitle': 'Xoá nhật ký cũ khỏi cơ sở dữ liệu?',
  'settings.auditArchive.confirmBody':
    '{soDong} dòng nhật ký cũ hơn ngày {ngay} sẽ được ghi ra tệp rồi xoá khỏi cơ sở dữ liệu. Tệp nằm lại trên máy chủ và tải về được, nhưng dữ liệu sẽ không còn tra cứu được trong trang Nhật ký.',
  'settings.auditArchive.done': 'Đã đưa {soDong} dòng ra tệp {name} và xoá khỏi cơ sở dữ liệu.',
  'settings.auditArchive.fileRemoved': 'Đã xoá tệp nhật ký.',
  'settings.auditArchive.noIndex':
    'Chỉ mục tìm kiếm nhật ký chưa bật trên cơ sở dữ liệu này (thiếu pg_trgm). Ô tìm kiếm vẫn cho kết quả đúng, nhưng sẽ chậm dần khi bảng lớn.',
  'settings.auditArchive.download': 'Tải về',
  'settings.auditArchive.col.file': 'Tệp',
  'settings.auditArchive.col.lines': 'Số dòng',
  'settings.auditArchive.col.size': 'Kích thước',
  'settings.tab.backup': 'Sao lưu',
  'settings.backup.scope':
    'Đây là sao lưu CSDL DNSHub — KHÔNG phải sao lưu Cloudflare. Bản ghi DNS thật nằm trên Cloudflare; khôi phục ở đây không đẩy gì ngược lên đó.',
  'settings.backup.create': 'Sao lưu ngay',
  'settings.backup.upload': 'Khôi phục từ tệp…',
  'settings.backup.download': 'Tải về',
  'settings.backup.restore': 'Khôi phục',
  'settings.backup.empty': 'Chưa có bản sao lưu nào.',
  'settings.backup.col.name': 'Tên tệp',
  'settings.backup.col.size': 'Kích thước',
  'settings.backup.col.created': 'Tạo lúc',
  'settings.backup.col.check': 'Kiểm tra',
  'settings.remote.fileDeleted': 'Đã xoá bản sao lưu trên kho ngoài.',
  'settings.remote.deleteFileTitle': 'Xoá bản sao lưu trên kho ngoài?',
  'settings.remote.deleteFileBody':
    'Xoá vĩnh viễn {name} khỏi {label}. Kho ngoài không có thùng rác, và không lượt sao lưu nào chép lại bản này.',
  'settings.backup.col.reason': 'Lý do',
  'settings.backup.reason.auto': 'Tự động theo lịch',
  'settings.backup.reason.manual': 'Thủ công',
  'settings.backup.reason.safety': 'Bản an toàn trước khôi phục',
  'settings.backup.reason.unknown': 'Không rõ',
  'settings.backup.col.actions': 'Hành động',
  // OQ-147 — ba kết quả, không phải hai. Chữ phải tự phân biệt được khi bỏ màu.
  'settings.backup.check': 'Kiểm tra',
  'settings.backup.check.running': 'Đang kiểm…',
  'settings.backup.check.unknown': 'Chưa kiểm',
  'settings.backup.check.pass': 'Đạt',
  'settings.backup.check.empty': 'Đạt nhưng rỗng',
  'settings.backup.check.broken': 'Hỏng',
  'settings.backup.check.brokenUnknown': 'Không mở được, máy chủ không nêu lý do.',
  'settings.backup.count.domains': 'tên miền',
  'settings.backup.count.users': 'người dùng',
  'settings.backup.count.cf_connections': 'kết nối',
  'settings.backup.count.dns_records': 'bản ghi',
  'settings.backup.createdToast': 'Đã tạo bản sao lưu mới.',
  'settings.backup.deletedToast': 'Đã xoá {name}.',
  'settings.backup.verifyOkToast': '{name} đọc được, dữ liệu còn nguyên.',
  'settings.backup.verifyBadToast': '{name} KHÔNG dùng để khôi phục được.',
  'settings.backup.restoredToast': 'Đã khôi phục xong.',
  'settings.backup.restored': 'Đã khôi phục {rows} hàng thuộc {tables} bảng.',
  'settings.backup.safety': 'Bản chụp an toàn trước khi ghi đè: {name}',
  'settings.backup.confirm.title': 'Khôi phục CSDL',
  'settings.backup.confirm.warn':
    'Thao tác này GHI ĐÈ TOÀN BỘ dữ liệu hiện tại. Hệ thống tự chụp một bản an toàn trước khi ghi đè.',
  'settings.backup.confirm.hint': 'Gõ đúng tên bản sao lưu để xác nhận: {name}',
  'settings.security.auth': 'Xác thực',
  'settings.security.access': 'Kiểm soát truy cập',
  'settings.security.password': 'Chính sách mật khẩu',
  'settings.sync.title': 'Đồng bộ tự động',
  'settings.sync.sub': 'Áp dụng cho mọi vùng DNS trong hệ thống',
  'settings.sync.note': 'Job đồng bộ do tiến trình nền thực hiện, không chặn thao tác của bạn.',
  'settings.sync.runNow': 'Đồng bộ toàn hệ thống ngay',
  'settings.sync.queued': 'Đã xếp job đồng bộ toàn hệ thống.',

  // ── Theo dõi job nền (docs/09 §9.4) ──────────────────────
  'settings.jobs.title': 'Trạng thái job nền',
  'settings.jobs.sub': 'Bốn job đồng bộ Cloudflare, làm mới mỗi 30 giây',
  'settings.jobs.never': 'Chưa chạy',
  // OQ-289 — 'chưa chạy' và 'không có việc' là hai chuyện khác nhau.
  'settings.jobs.idle': 'Không có việc',
  'settings.jobs.queued': '{count} việc đang chờ',
  'setting.sync.verify_ns_interval_minutes': 'Chu kỳ xác minh nameserver (phút)',
  'setting.sync.verify_ns_interval_minutes.hint':
    'Kiểm tra lại nameserver cho tên miền đang chờ kích hoạt.',
  'setting.sync.dns_sync_interval_minutes': 'Chu kỳ đồng bộ bù bản ghi (phút)',
  'setting.sync.dns_sync_interval_minutes.hint':
    'Nhịp quét hàng đợi bù. Việc chỉ vào hàng đợi khi một thao tác ghi bản ghi DNS thất bại — không có việc thì job không làm gì.',
  'settings.jobs.every': 'mỗi {minutes} phút',
  'settings.jobs.failures': '{count} lần hỏng trong 24 giờ',
  'settings.jobs.empty': 'Chưa có lần chạy nào được ghi lại.',
  'settings.jobs.colKind': 'Job',
  'settings.jobs.colTarget': 'Đối tượng',
  'settings.jobs.colStatus': 'Trạng thái',
  'settings.jobs.colAttempts': 'Số lần thử',
  'settings.jobs.colCreated': 'Xếp hàng lúc',
  'settings.jobs.kind.zone_sync': 'Đồng bộ vùng & bản ghi',
  'settings.jobs.kind.token_check': 'Kiểm tra token',
  'settings.jobs.kind.dns_sync': 'Đồng bộ bù bản ghi',
  'settings.jobs.kind.verify_ns': 'Xác minh nameserver',
  'settings.jobs.kind.backup': 'Sao lưu cơ sở dữ liệu',
  'settings.jobs.status.queued': 'Đang chờ',
  'settings.jobs.status.running': 'Đang chạy',
  'settings.jobs.status.done': 'Xong',
  'settings.jobs.status.failed': 'Thất bại',
  'settings.policy.title': 'Quy tắc khi người dùng thêm tên miền',
  'settings.policy.sub': 'Áp dụng cho vai trò Thành viên',
  // FR-112 mục 1 "ai được thêm tên miền" — bảng chỉ đọc, xem OQ-037 / OQ-140.
  'settings.policy.domAdd.title': 'Ai được thêm tên miền',
  'settings.policy.domAdd.sub':
    'Các vai trò đang bật năng lực “Thêm tên miền mới” (dom.add). Đây là bảng chỉ đọc.',
  'settings.policy.domAdd.manage': 'Mở trang Vai trò',
  'settings.policy.domAdd.colRole': 'Vai trò',
  'settings.policy.domAdd.colUsers': 'Đang gán cho',
  'settings.policy.domAdd.system': 'Hệ thống',
  'settings.policy.domAdd.default': 'Mặc định',
  'settings.policy.domAdd.noneTitle': 'Không vai trò nào được thêm tên miền',
  'settings.policy.domAdd.noneBody':
    'Hiện chưa có vai trò nào bật năng lực “Thêm tên miền mới”. Chỉ quản trị viên mới thêm được tên miền.',
  'settings.policy.domAdd.needRolesTitle': 'Cần quyền “Quản lý vai trò” để xem danh sách',
  'settings.policy.domAdd.needRolesBody':
    'Danh sách vai trò do trang Vai trò cung cấp và cần năng lực adm.roles. Tài khoản của bạn chỉ có adm.settings nên phần này để trống.',
  'settings.policy.domAdd.foot':
    'Không có công tắc nào ở đây: quyền thêm tên miền chỉ đổi được ở trang Vai trò, và mọi thay đổi đều vào nhật ký.',
  'settings.smtp.title': 'Máy chủ gửi thư (SMTP)',
  'settings.smtp.sender': 'Người gửi',
  'settings.smtp.test': 'Gửi thư kiểm tra',
  'settings.smtp.testTitle': 'Gửi thư kiểm tra',
  'settings.smtp.testSubtitle': 'Thư dùng đúng cấu hình SMTP đang lưu.',
  'settings.smtp.testTo': 'Gửi tới email',
  'settings.smtp.sent': 'Đã gửi thư kiểm tra tới {email}.',
  'settings.smtp.eventsNote':
    'Danh sách sự kiện gửi thư cố định theo docs/07 §7.9; người dùng tự bật/tắt trong hồ sơ cá nhân.',
  'settings.branding.org': 'Thông tin tổ chức',
  'settings.branding.appearance': 'Giao diện mặc định',
  'settings.branding.upload': 'Tải ảnh lên',
  'settings.branding.uploaded': 'Đã cập nhật ảnh thương hiệu.',
  'settings.branding.noImage': 'Chưa có ảnh',
  'settings.saved': 'Đã lưu {count} thay đổi.',
  'settings.changedCount': '{count} thay đổi chưa lưu',
  'settings.auditNote': 'Mọi thay đổi cài đặt được ghi nhật ký kèm giá trị cũ → mới.',
  'settings.reset.title': 'Khôi phục mặc định',
  'settings.reset.subtitle': 'Áp dụng cho tab {tab}.',
  'settings.reset.body':
    'Mọi khoá trong tab này sẽ trở về giá trị mặc định của hệ thống. Mật khẩu SMTP được giữ nguyên.',
  'settings.reset.submit': 'Khôi phục',

  // ── Nhãn từng khoá cài đặt ───────────────────────────────
  'setting.security.force_2fa_all': 'Bắt buộc 2FA cho mọi tài khoản',
  'setting.security.force_2fa_all.hint':
    'Người dùng chưa bật sẽ được yêu cầu thiết lập ở lần đăng nhập kế tiếp.',
  'setting.security.min_password_length': 'Độ dài mật khẩu tối thiểu',
  'setting.security.min_password_length.hint': 'Từ 8 đến 64 ký tự.',
  'setting.security.require_uppercase': 'Bắt buộc có chữ hoa',
  'setting.security.require_lowercase': 'Bắt buộc có chữ thường',
  'setting.security.require_number': 'Bắt buộc có chữ số',
  'setting.security.require_symbol': 'Bắt buộc có ký tự đặc biệt',
  'setting.security.require_symbol.hint': 'Khuyến khích nhưng không bắt buộc theo mặc định.',
  'setting.security.password_history': 'Số mật khẩu gần nhất bị chặn',
  'setting.security.password_history.hint': 'Đặt 0 để bỏ kiểm tra.',
  'setting.security.password_expiry_days': 'Hạn đổi mật khẩu (ngày)',
  'setting.security.password_expiry_days.hint': 'Đặt 0 để không bắt buộc đổi.',
  'setting.security.check_pwned_passwords': 'Đối chiếu danh sách mật khẩu lộ',
  'setting.security.check_pwned_passwords.hint':
    'Dùng k-anonymity tới api.pwnedpasswords.com; tắt khi máy chủ không có internet.',
  'setting.security.max_failed_logins': 'Số lần sai trước khi khoá',
  'setting.security.max_failed_logins.hint':
    'Vượt ngưỡng thì tài khoản chuyển sang trạng thái bị khoá.',
  'setting.security.lockout_minutes': 'Thời gian khoá (phút)',
  'setting.security.lockout_minutes.hint': 'Hết thời gian này người dùng đăng nhập lại được.',
  'setting.security.session_absolute_days': 'Thời hạn phiên tuyệt đối (ngày)',
  'setting.security.session_absolute_days.hint':
    'Hết hạn thì phải đăng nhập lại dù đang hoạt động.',
  'setting.security.session_idle_days': 'Không hoạt động thì hết hạn sau (ngày)',
  'setting.security.session_idle_days.hint': 'Tính từ lần dùng gần nhất của phiên.',
  'setting.security.allow_multiple_sessions': 'Cho phép nhiều phiên đồng thời',
  'setting.security.allow_multiple_sessions.hint':
    'Tắt để mỗi tài khoản chỉ đăng nhập trên một thiết bị.',
  'setting.security.force_2fa_roles': 'Vai trò bắt buộc bật 2FA',
  'setting.security.force_2fa_roles.hint':
    'Mỗi dòng một slug vai trò, ví dụ: admin. Người thuộc vai trò đó phải thiết lập 2FA ngay sau đăng nhập. Bỏ trống nếu đã bật công tắc ở trên.',
  'setting.security.admin_ip_allowlist': 'Danh sách CIDR cho phép truy cập quản trị',
  'setting.security.admin_ip_allowlist.hint':
    'Mỗi dòng một dải, ví dụ: 203.0.113.0/24. ĐANG CÓ HIỆU LỰC: để trống nghĩa là không giới hạn; khi có ít nhất một dải, mọi IP ngoài danh sách sẽ bị chặn khỏi Người dùng · Vai trò · Mức quyền · Cài đặt. Nhớ thêm IP của chính bạn trước khi lưu.',
  'setting.security.invitation_expiry_days': 'Hạn lời mời mặc định (ngày)',
  'setting.security.invitation_expiry_days.hint':
    'Áp dụng khi mời người dùng mà không chọn hạn riêng.',
  'setting.security.password_reset_ttl_minutes': 'Hạn liên kết đặt lại mật khẩu (phút)',
  'setting.security.password_reset_ttl_minutes.hint': 'Liên kết chỉ dùng được một lần.',
  'setting.security.geoip_enabled': 'Tra vị trí gần đúng từ địa chỉ IP',
  'setting.security.geoip_enabled.hint':
    'Hiện cột Vị trí ở danh sách Phiên & thiết bị. Địa chỉ IP của người đăng nhập được gửi tới dịch vụ ipwho.is qua kết nối mã hoá; tắt đi thì không gửi gì ra ngoài và cột Vị trí để trống. Kết quả chỉ là ước lượng, có thể lệch vài trăm ki-lô-mét.',
  'setting.security.trusted_device_days': 'Tin thiết bị trong (ngày)',
  'setting.security.trusted_device_days.hint': 'Thiết bị đã tin thì bỏ qua bước 2FA.',
  'setting.sync.zone_interval_minutes': 'Chu kỳ đồng bộ zone (phút)',
  'setting.sync.zone_interval_minutes.hint':
    'Đồng bộ trạng thái vùng VÀ toàn bộ bản ghi DNS từ Cloudflare về. Đây là nhịp đồng bộ bản ghi định kỳ.',
  'setting.sync.token_check_interval_minutes': 'Chu kỳ kiểm tra token (phút)',
  'setting.sync.token_check_interval_minutes.hint': 'Kiểm tra token Cloudflare còn hiệu lực không.',
  'setting.sync.max_retries': 'Số lần thử lại',
  'setting.sync.max_retries.hint': 'Áp dụng cho mỗi job đồng bộ thất bại.',
  'setting.sync.backoff_base_ms': 'Thời gian chờ cơ sở (ms)',
  'setting.sync.backoff_base_ms.hint':
    'Khi Cloudflare trả 429, thời gian chờ tăng dần từ giá trị này.',
  'setting.policy.require_admin_approval_for_domains': 'Cần quản trị viên duyệt tên miền mới',
  'setting.policy.require_admin_approval_for_domains.hint':
    'Tên miền mới ở trạng thái chờ duyệt trước khi tạo vùng trên Cloudflare.',
  'setting.policy.max_domains_per_user': 'Hạn mức tên miền mỗi người dùng',
  'setting.policy.max_domains_per_user.hint': 'Đặt 0 để bỏ giới hạn.',
  'setting.policy.max_connections_per_user': 'Hạn mức kết nối mỗi người dùng',
  'setting.policy.max_connections_per_user.hint': 'Đặt 0 để bỏ giới hạn.',
  'setting.policy.allow_user_invites': 'Cho phép người dùng tự mời cộng tác viên',
  'setting.policy.allow_user_invites.hint':
    'Tắt nếu chỉ quản trị viên được chia sẻ quyền tên miền.',

  'settings.signup.title': 'Tự đăng ký tài khoản',
  'settings.signup.sub':
    'Người lạ tạo tài khoản mà không cần lời mời. Họ chỉ thấy tên miền do chính họ thêm.',
  'setting.policy.allow_public_signup': 'Cho phép tự đăng ký',
  'setting.policy.allow_public_signup.hint':
    'Tắt là đóng trang đăng ký ngay lập tức; liên kết ở màn hình đăng nhập cũng biến mất. Tài khoản đã tạo không bị ảnh hưởng.',
  'setting.security.signup_rate_limit': 'Số lượt đăng ký tối đa cho mỗi địa chỉ IP',
  'setting.security.signup_rate_limit.hint':
    'Tính trong khoảng thời gian bên dưới. Vượt ngưỡng thì IP đó bị từ chối tới hết khoảng.',
  'setting.security.signup_rate_window_minutes': 'Khoảng thời gian tính giới hạn (phút)',
  'setting.security.signup_rate_window_minutes.hint':
    'Ví dụ 3 lượt trong 60 phút. Đặt dài hơn thì chặn được máy gửi rác kiên nhẫn, nhưng người dùng thật gõ sai vài lần cũng phải chờ lâu hơn.',
  'setting.security.turnstile_enabled': 'Bật captcha Cloudflare Turnstile',
  'setting.security.turnstile_enabled.hint':
    'Chặn được cả máy gửi rác biết đổi IP. Lấy hai khoá ở Cloudflare Dashboard → Turnstile.',
  'setting.security.turnstile_site_key': 'Site key',
  'setting.security.turnstile_site_key.hint':
    'Khoá công khai — nằm trong mã trang đăng ký, không phải bí mật.',
  'setting.security.turnstile_secret_key': 'Secret key',
  'setting.security.turnstile_secret_key.hint':
    'Khoá bí mật — được mã hoá trước khi lưu và không bao giờ hiện lại. Để trống nếu không muốn đổi.',
  'setting.security.turnstile_missing_keys':
    'Còn thiếu khoá nên captcha CHƯA có tác dụng. Hệ thống vẫn nhận đăng ký như khi tắt captcha.',
  'setting.smtp.provider': 'Đường gửi thư',
  'setting.smtp.provider.hint':
    'SMTP dùng được với mọi nhà cung cấp. Resend gửi qua HTTPS — chỉ cần một API key, không cần cổng hay TLS, không bị nhà mạng chặn.',
  'setting.smtp.resendKey': 'Resend API key',
  'setting.smtp.resendKey.hint':
    'Lấy ở resend.com → API Keys. Tên miền gửi phải được xác minh trên Resend, nếu không thư sẽ bị từ chối.',
  'setting.smtp.host': 'Máy chủ',
  'setting.smtp.port': 'Cổng',
  'setting.smtp.user': 'Tài khoản',
  'setting.smtp.password': 'Mật khẩu',
  'setting.smtp.password.hint':
    'Để nguyên "***" nghĩa là không đổi. Giá trị được mã hoá AES-256-GCM khi lưu.',
  'setting.smtp.tlsMismatch465':
    'Cổng 465 đòi TLS ngay từ đầu — hãy BẬT công tắc, nếu không kết nối sẽ treo tới khi hết giờ.',
  'setting.smtp.tlsMismatchStarttls':
    'Cổng {port} dùng STARTTLS — hãy TẮT công tắc, nếu không máy chủ trả lỗi "wrong version number". Chỉ cổng 465 mới bật TLS.',
  'setting.smtp.secure': 'Kết nối bảo mật (TLS)',
  'setting.smtp.secure.hint': 'Bật cho cổng 465, tắt cho cổng 587 dùng STARTTLS.',
  'setting.smtp.from_email': 'Email người gửi',
  'setting.smtp.from_name': 'Tên người gửi',
  'setting.branding.app_name': 'Tên hệ thống',
  'setting.branding.app_name.hint':
    'Hiện ở thanh bên, thanh tiêu đề và trong thư gửi đi. Để trống thì dùng DNSHub.',
  'setting.branding.tagline': 'Dòng phụ dưới tên',
  'setting.branding.tagline.hint':
    'Dòng chữ nhỏ ngay dưới tên hệ thống. Để trống thì dùng bản dịch theo ngôn ngữ đang chọn.',
  'setting.branding.footer_text': 'Chân trang',
  'setting.branding.accent_color': 'Màu nhấn',
  'setting.branding.accent_color.hint': 'Giá trị CSS, ví dụ: oklch(0.615 0.176 45).',
  'setting.branding.default_locale': 'Ngôn ngữ mặc định',
  'setting.branding.default_locale.hint': 'Áp dụng cho tài khoản mới.',
  'setting.branding.default_timezone': 'Múi giờ mặc định',
  'setting.branding.logo_light': 'Logo nền sáng',
  'setting.branding.logo_dark': 'Logo nền tối',
  'setting.branding.favicon': 'Favicon',

  // ── Nhật ký hoạt động · FR-130…135 ───────────────────────
  'audit.title': 'Nhật ký hoạt động',
  'audit.ledeAdmin':
    'Mọi thao tác trên tên miền, người dùng và cài đặt đều được ghi lại kèm thời điểm, tác nhân và địa chỉ IP.',
  'audit.ledeUser': 'Bạn đang xem nhật ký của chính mình và của các tên miền bạn sở hữu.',
  'audit.range': 'Khoảng thời gian',
  'audit.range.24h': '24 giờ qua',
  'audit.range.7d': '7 ngày qua',
  'audit.range.30d': '30 ngày qua',
  'audit.range.custom': 'Tuỳ chọn…',
  'audit.from': 'Từ ngày',
  'audit.to': 'Đến ngày',
  'audit.export': 'Xuất nhật ký',
  'audit.system': 'Hệ thống',
  'audit.expand': 'Xem chi tiết trước/sau',
  'audit.stat.total': 'Sự kiện trong khoảng',
  'audit.stat.dns': 'Thay đổi DNS',
  'audit.stat.dnsSub': 'Thêm, sửa, xoá bản ghi',
  'audit.stat.security': 'Sự kiện bảo mật',
  'audit.stat.failures': 'lần thất bại',
  'audit.stat.noFailure': 'Không có sự kiện thất bại',
  'audit.stat.permissions': 'Người dùng & quyền',
  'audit.stat.permissionsSub': 'Mời, đổi vai trò, cấp quyền',
  'audit.filter.all': 'Tất cả',
  'audit.filter.dns': 'DNS',
  'audit.filter.domain': 'Tên miền',
  'audit.filter.user': 'Người dùng',
  'audit.filter.security': 'Bảo mật',
  'audit.filter.system': 'Hệ thống',
  'audit.searchPlaceholder': 'Tìm theo tác nhân, hành động, đối tượng, địa chỉ IP…',
  'audit.filterResultLabel': 'Lọc theo kết quả',
  'audit.filterResultAll': 'Mọi kết quả',
  'audit.searchAria': 'Tìm sự kiện',
  'audit.col.at': 'Thời điểm',
  'audit.col.actor': 'Tác nhân',
  'audit.col.action': 'Hành động',
  'audit.col.target': 'Đối tượng',
  'audit.col.ip': 'Địa chỉ IP',
  'audit.col.result': 'Kết quả',
  'audit.retention': 'Nhật ký chỉ ghi thêm và được lưu tối thiểu 365 ngày.',
  'audit.empty.title': 'Chưa có sự kiện nào',
  'audit.empty.body': 'Không có dòng nhật ký nào khớp khoảng thời gian và bộ lọc hiện tại.',
  'audit.attention.title': 'Cảnh báo cần xử lý',
  'audit.attention.sub': 'Sự kiện có rủi ro trong khoảng đang xem',
  'audit.attention.empty': 'Không có cảnh báo nào',
  'audit.distribution.title': 'Phân bố sự kiện',
  'audit.detail.at': 'Thời điểm',
  'audit.detail.target': 'Đối tượng',
  'audit.detail.userAgent': 'Trình duyệt',
  'audit.detail.requestId': 'Request id',
  'audit.detail.before': 'Trước',
  'audit.detail.after': 'Sau',

  // ── Phân trang dùng chung ────────────────────────────────
  'common.prev': 'Trước',
  'common.next': 'Sau',
  'common.pageOf': 'Trang {page}/{total}',
  'common.perPage': 'Số dòng mỗi trang',

  // ── M3 · Kết nối Cloudflare (FR-100…109) ─────────────────
  'conn.title': 'Quản lý kết nối Cloudflare',
  'conn.ledeAdmin':
    'Mọi kết nối Cloudflare trong hệ thống. Chọn một kết nối làm mặc định — người dùng chưa có token riêng sẽ thêm tên miền vào tài khoản Cloudflare đó.',
  'conn.ledeUser':
    'Các tài khoản Cloudflare bạn đã kết nối. Khi thêm tên miền, bạn chọn kết nối muốn dùng; nếu chưa có kết nối nào, tên miền sẽ được tạo trên tài khoản Cloudflare mặc định của hệ thống.',
  'conn.add': 'Thêm kết nối',
  'conn.addFirst': 'Thêm kết nối đầu tiên',
  'conn.statConnections': 'Kết nối',
  'conn.statConnectionsAll': 'Trên toàn hệ thống',
  'conn.statConnectionsMine': 'Do bạn thêm',
  'conn.statZones': 'Tên miền',
  'conn.statZonesNote': 'Đang quản lý qua các kết nối này',
  'conn.statBad': 'Cần chú ý',
  'conn.statBadNote': 'Token lỗi hoặc đang tạm ngưng',
  'conn.statDefault': 'Kết nối mặc định',
  'conn.statDefaultNote': 'Dùng khi người thêm chưa có token',
  'conn.noDefault': 'Chưa đặt',
  'conn.noteAdmin':
    'Chỉ một kết nối được đặt mặc định tại một thời điểm. Đặt mặc định cho kết nối khác sẽ tự động bỏ cờ ở kết nối hiện tại.',
  'conn.noteUser':
    'Bạn chỉ nhìn thấy và sửa được kết nối do chính mình thêm. Token được mã hoá, quản trị viên không đọc được giá trị gốc.',
  'conn.listAll': 'Tất cả kết nối',
  'conn.listMine': 'Kết nối của tôi',
  'conn.listSubAll': 'Kết nối mặc định luôn đứng đầu, sau đó sắp theo tên',
  'conn.listSubMine': 'Chọn một trong các kết nối này khi thêm tên miền mới',
  'conn.searchPlaceholder': 'Tìm kết nối, account ID, chủ sở hữu…',
  'conn.filter.all': 'Tất cả',
  'conn.filter.ok': 'Hoạt động',
  'conn.filter.invalid': 'Token lỗi',
  'conn.filter.paused': 'Tạm ngưng',
  'conn.col.name': 'Kết nối',
  'conn.col.owner': 'Chủ sở hữu',
  'conn.col.status': 'Trạng thái',
  'conn.col.domains': 'Tên miền',
  'conn.col.actions': 'Thao tác',
  'conn.domainsLink': 'Xem tên miền đang dùng “{name}”',
  'conn.footCount': '{count} kết nối',
  'conn.accountId': 'Account ID',
  'conn.accounts': 'Tài khoản Cloudflare mà token này truy cập được',
  'conn.accountName': 'Tên tài khoản',
  'conn.accountZones': 'Tên miền',
  'conn.accountPrimary': 'Mặc định',
  'conn.accountsNone':
    'Token không đọc được danh sách tài khoản. Kiểm tra lại quyền của token trên Cloudflare.',
  'conn.accountsHint':
    'Do Cloudflare trả về, không sửa được ở đây. Tài khoản “Mặc định” là nơi tên miền mới được tạo khi không chọn tài khoản khác.',
  'conn.token': 'Token',
  'conn.checked': 'Kiểm tra',
  'conn.never': 'Chưa kiểm tra',
  'conn.default': 'Mặc định hệ thống',
  'conn.setDefault': 'Đặt mặc định',
  'conn.verify': 'Kiểm tra',
  'conn.rotate': 'Sửa',
  'conn.status.ok': 'Hoạt động',
  'conn.status.paused': 'Tạm ngưng',
  'conn.status.invalid': 'Token lỗi',
  'conn.emptyTitle': 'Bạn chưa có kết nối Cloudflare nào',
  'conn.emptyBodyWithDefault':
    'Thêm token API của tài khoản Cloudflare để tự quản lý vùng DNS. Trong lúc chờ, tên miền bạn thêm sẽ nằm trên tài khoản mặc định của hệ thống — {name}.',
  'conn.emptyBodyNoDefault':
    'Thêm token API của tài khoản Cloudflare để tự quản lý vùng DNS. Hệ thống chưa có kết nối mặc định nên bạn cần thêm kết nối trước khi thêm tên miền.',
  'conn.emptyFiltered': 'Không có kết nối nào khớp bộ lọc.',
  'conn.newTitle': 'Thêm kết nối Cloudflare',
  'conn.newSub': 'Tạo API token trên Cloudflare với quyền Zone · DNS · Edit và Zone · Zone · Read.',
  'conn.name': 'Tên gợi nhớ',
  'conn.namePlaceholder': 'VD: Cloudflare cá nhân',
  'conn.apiToken': 'API token',
  'conn.apiTokenPlaceholder': 'Dán token vừa tạo trên Cloudflare',
  'conn.apiTokenHint': 'Token được mã hoá khi lưu và chỉ hiển thị 4 ký tự cuối.',
  'conn.accountEmail': 'Email tài khoản',
  'conn.owner': 'Kết nối thuộc về',
  'conn.ownerHint': 'Quản trị viên có thể thêm kết nối thay cho người dùng khác.',
  'conn.ownerSelf': '— Chính tôi —',

  // Hướng dẫn lấy token — docs/06 §6.2
  'conn.guideShow': 'Chưa có token? Xem hướng dẫn lấy',
  'conn.guideHide': 'Ẩn hướng dẫn',
  'conn.guideTitle': 'Tạo API token trên Cloudflare',
  'conn.guideStep1': 'Đăng nhập Cloudflare rồi mở',
  'conn.guideStep2': 'Bấm “Create Token”, chọn “Create Custom Token” ở cuối danh sách mẫu.',
  'conn.guideStep3':
    'Ở mục Permissions, thêm đủ sáu dòng dưới đây. Thiếu dòng nào thì mất đúng chức năng ghi ở cột bên phải.',
  'conn.guideStep4':
    'Ở Account Resources chọn tài khoản của bạn, rồi Continue → Create Token và sao chép token. Cloudflare chỉ hiện token đúng một lần.',
  'conn.guidePerm': 'Permission',
  'conn.guidePermUse': 'Dùng cho',
  'dns.priorityShort': 'ưu tiên {n}',
  'ssl.daysLeft': '{n} ngày',
  'conn.guidePerm.zoneRead': 'Liệt kê & đọc zone',
  'conn.guidePerm.zoneEdit': 'Thêm zone mới, đổi gói, pause, kiểm tra lại NS',
  'conn.guidePerm.dnsEdit': 'CRUD bản ghi DNS, nhập/xuất',
  'conn.guidePerm.zoneSettings': 'SSL mode, TLS tối thiểu, HSTS, Always Use HTTPS',
  'conn.guidePerm.sslRead': 'Đọc chứng chỉ, ngày hết hạn',
  'conn.guidePerm.cachePurge': 'Xoá cache',
  'conn.guidePerm.accountRead':
    'Lấy account_id — bắt buộc, không có thì không thêm được tên miền mới',
  'conn.guidePerm.tunnel': 'Tạo và cấu hình Cloudflare Tunnel — chỉ cần nếu bạn dùng tính năng này',
  'conn.guidePermOptional': 'Tuỳ chọn',
  'conn.guideSecurity':
    'Token được mã hoá trước khi lưu và không bao giờ trả về nguyên vẹn — màn hình chỉ hiện 4 ký tự cuối.',
  'conn.makeDefault': 'Đặt làm kết nối mặc định hệ thống',
  'conn.makeDefaultSub': 'Tên miền của người chưa có token riêng sẽ được tạo trên tài khoản này.',
  'conn.save': 'Lưu kết nối',
  'conn.editTitle': 'Sửa kết nối',
  'conn.editSub': 'Kết nối của {name}',
  'conn.currentToken': 'Token hiện tại',
  'conn.pause': 'Tạm ngưng kết nối',
  'conn.pauseSub': 'Giữ cấu hình nhưng ngừng đồng bộ và mọi thay đổi DNS qua kết nối này.',
  'conn.rotateTitle': 'Xoay vòng API token',
  'conn.rotateSub': 'Token cũ ngừng hoạt động ngay khi token mới được lưu.',
  'conn.rotateWarn':
    'Nếu token mới thiếu quyền, việc đồng bộ và mọi thay đổi DNS sẽ thất bại cho tới khi bạn sửa lại.',
  'conn.rotateField': 'Token Cloudflare mới',
  'conn.rotateSave': 'Lưu token mới',
  'conn.deleteTitle': 'Xoá kết nối',
  'conn.deleteSub': 'Gỡ “{name}” khỏi DNSHub.',
  'conn.deleteWarn':
    '{count} vùng DNS đang gắn với kết nối này. Sau khi xoá, DNSHub ngừng đọc và ghi các vùng đó — bản ghi trên Cloudflare vẫn giữ nguyên.',
  'conn.deleteConfirm': 'Nhập tên kết nối để xác nhận',
  'conn.defaultTitle': 'Đặt kết nối mặc định hệ thống',
  'conn.defaultConfirm':
    'Từ giờ, tên miền của người dùng chưa có token riêng sẽ được tạo trên “{name}”. Kết nối mặc định hiện tại sẽ bị bỏ cờ.',
  'conn.created': 'Đã thêm kết nối Cloudflare.',
  'conn.updated': 'Đã lưu thay đổi.',
  'conn.rotated': 'Đã thay token Cloudflare mới.',
  'conn.deleted': 'Đã xoá kết nối.',
  'conn.defaulted': 'Đã đặt “{name}” làm kết nối mặc định.',
  'conn.verifiedOk': 'Kết nối “{name}” hợp lệ · {count} vùng DNS.',
  'conn.verifiedBad': 'Kết nối “{name}” lỗi xác thực.',
  'conn.missingScopes': 'Token thiếu quyền: {list}',

  // ── M4 · Tên miền (FR-020…033) ───────────────────────────
  'domains.title': 'Tên miền',
  'domains.ledeAdmin':
    'Toàn bộ vùng DNS được đồng bộ từ Cloudflare. Với vai trò quản trị, bạn thấy tên miền của mọi người dùng.',
  'domains.ledeUser':
    'Danh sách chỉ hiển thị tên miền do bạn thêm hoặc được cấp quyền. Tên miền của người khác không xuất hiện ở đây.',
  'domains.filteredByConnection': 'Đang lọc: chỉ tên miền dùng kết nối “{name}”.',
  'domains.thisConnection': 'kết nối này',
  'domains.clearConnectionFilter': 'Bỏ lọc',
  'domains.scopeNote': 'Bạn đang ở phạm vi cá nhân. Tên miền bạn thêm chỉ mình bạn thấy.',
  'domains.add': 'Thêm tên miền',

  // Nhập tên miền có sẵn từ Cloudflare — OQ-115
  'domains.import': 'Nhập từ Cloudflare',
  'domains.importTitle': 'Nhập tên miền có sẵn từ Cloudflare',
  'domains.importSub':
    'Chọn những vùng DNS đang có trên tài khoản Cloudflare để đưa vào hệ thống quản lý.',
  'domains.importConnection': 'Lấy từ kết nối',
  'domains.importDomain': 'Tên miền',
  'domains.importStatus': 'Trạng thái',
  'domains.importPlan': 'Gói',
  'domains.importPick': 'Chọn',
  'domains.importAll': 'Chọn tất cả ({n})',
  'domains.importNone': 'Bỏ chọn tất cả',
  'domains.importSelected': 'Đã chọn {n} tên miền',
  'domains.importAction': 'Nhập vào hệ thống',
  'domains.importAlready': 'Đã có trong hệ thống',
  'domains.importNoConn': '— Chưa có kết nối Cloudflare nào hoạt động —',
  'domains.importEmpty': 'Không tìm thấy vùng DNS nào',
  'domains.importEmptyHint':
    'Kết nối này chưa quản lý vùng DNS nào, hoặc token thiếu quyền Zone → Zone → Read.',
  'domains.importScan': 'Quét luôn bản ghi DNS',
  'domains.importScanSub': 'Tải toàn bộ bản ghi của từng vùng về ngay sau khi nhập.',
  'domains.importDone': 'Đã nhập {n} tên miền và {r} bản ghi DNS.',
  // OQ-282 — nhập chạy nền, tiến độ hiện trên header.
  'domains.importQueued':
    'Đã xếp {n} tên miền vào hàng đợi. Theo dõi tiến độ trên thanh trên cùng.',
  'domains.import.progress': 'Đang nhập {done}/{total} tên miền từ Cloudflare',
  'domains.import.progressAria': 'Tiến độ nhập tên miền từ Cloudflare',
  // OQ-283 — đối chiếu DNS sau khi gắn lại kết nối.
  'domains.import.progressReconcile': 'Đang đối chiếu DNS {done}/{total} tên miền',
  'reconcile.title': 'Đối chiếu DNS',
  'reconcile.sub':
    'Những tên miền có khác biệt giữa dữ liệu trong hệ thống và Cloudflare, sau khi bạn gắn lại kết nối.',
  'reconcile.note':
    'Đồng bộ tự động đang tạm hoãn cho các tên miền dưới đây. Chọn xong thì đồng bộ chạy lại như thường.',
  'reconcile.colDomain': 'Tên miền',
  'reconcile.colDbOnly': 'Chỉ trong hệ thống',
  'reconcile.colCfOnly': 'Chỉ trên Cloudflare',
  'reconcile.colDiffer': 'Khác giá trị',
  'reconcile.colSince': 'Phát hiện lúc',
  'reconcile.colActions': 'Thao tác',
  'reconcile.compare': 'So sánh',
  'reconcile.skip': 'Bỏ qua',
  'reconcile.applyAll': 'Áp bản Cloudflare cho tất cả',
  'reconcile.applyAllWarn':
    'Sẽ lấy toàn bộ bản ghi từ Cloudflare cho {n} tên miền. Bản ghi chỉ có trong hệ thống sẽ bị xoá.',
  'reconcile.applyAllHint':
    'Cloudflare không bị thay đổi gì. Thao tác này chỉ ghi đè dữ liệu phía hệ thống.',
  'reconcile.applied': 'Đã áp bản Cloudflare cho {n} tên miền.',
  'reconcile.appliedWithErrors':
    'Đã áp cho {n} tên miền, {e} tên miền lỗi — xem Nhật ký hoạt động.',
  'reconcile.emptyTitle': 'Không có tên miền nào cần đối chiếu',
  'reconcile.emptyHint': 'Mọi tên miền đang khớp với Cloudflare, hoặc bạn đã xử lý hết.',
  // OQ-286 — lịch sao lưu tự động.
  'settings.backupSchedule.title': 'Lịch sao lưu tự động',
  'settings.backupSchedule.sub': 'Máy chủ tự tạo bản sao lưu theo chu kỳ và dọn bản cũ.',
  'settings.backupSchedule.enabled': 'Bật sao lưu tự động',
  'settings.backupSchedule.enabledSub': 'Tắt thì chỉ còn sao lưu thủ công bằng nút bên dưới.',
  'settings.backupSchedule.interval': 'Chu kỳ (giờ)',
  'settings.backupSchedule.intervalHint': 'Mặc định 24 giờ. Tối thiểu 1, tối đa 168 (một tuần).',
  'settings.backupSchedule.keep': 'Giữ lại bao nhiêu bản',
  'settings.backupSchedule.keepHint': 'Bản cũ hơn sẽ bị xoá sau mỗi lượt sao lưu. Mặc định 7.',
  'settings.backupSchedule.note':
    'Bản sao lưu nằm trên chính máy chủ. Muốn an toàn khi mất máy, hãy bật thêm Kho sao lưu ngoài ở khối bên dưới.',
  'settings.backupSchedule.saved': 'Đã lưu lịch sao lưu.',

  // OQ-286 — hướng dẫn lấy khoá cho kho sao lưu ngoài.
  'domains.importCompare': 'So sánh DNS',
  'domains.importExists': 'Đã từng thêm — so sánh trước khi nhập lại',
  'domains.reimportTitle': 'So sánh DNS · {name}',
  'domains.reimportSub':
    'Tên miền này đã từng được thêm vào hệ thống. Chọn giữ bản ghi phía nào cho từng dòng. Bước áp chỉ tạo hoặc cập nhật trên Cloudflare, không bao giờ xoá.',
  'domains.reimportRecord': 'Bản ghi',
  'domains.reimportState': 'Trạng thái',
  'domains.reimportDb': 'Trong hệ thống (CSDL)',
  'domains.reimportCf': 'Trên Cloudflare',
  'domains.reimportChoice': 'Giữ lại',
  'domains.reimportState.same': 'Trùng khớp',
  'domains.reimportState.differ': 'Khác giá trị',
  'domains.reimportState.db_only': 'Chỉ có ở CSDL',
  'domains.reimportState.cf_only': 'Chỉ có ở Cloudflare',
  'domains.reimportKeep': 'Giữ',
  'domains.reimportDrop': 'Không giữ',
  'domains.reimportUseCf': 'Lấy phía Cloudflare',
  'domains.reimportUseDb': 'Đẩy phía CSDL lên',
  'domains.reimportApply': 'Áp lựa chọn',
  'domains.reimportCount': '{n} bản ghi',
  'domains.reimportEmpty': 'Không có bản ghi để so sánh',
  'domains.reimportEmptyHint': 'Hai phía đang giống nhau hoặc chưa có bản ghi nào.',
  'domains.reimportDone': 'Đã tạo {c}, cập nhật {u} trên Cloudflare · nhập {i}, bỏ {d} khỏi CSDL.',
  'domains.sync': 'Đồng bộ Cloudflare',
  'domains.statTotal': 'Tổng tên miền',
  'domains.statActive': 'Đang hoạt động',
  'domains.statActiveNote': 'Nameserver đã trỏ đúng',
  'domains.statPending': 'Chờ nameserver',
  'domains.statPendingNote': 'Cần trỏ nameserver để kích hoạt',
  'domains.statPaused': 'Tạm dừng',
  'domains.statPausedNote': 'Đang ngừng phục vụ qua Cloudflare',
  'domains.statTotalNote': 'Trong phạm vi của bạn',
  'domains.filterAll': 'Tất cả',
  'domains.filterActive': 'Hoạt động',
  'domains.filterPending': 'Chờ NS',
  'domains.filterPaused': 'Tạm dừng',
  'domains.filterSyncPaused': 'Ngừng đồng bộ',
  'domains.filterError': 'Lỗi',
  'domains.searchPlaceholder': 'Tìm tên miền, kết nối Cloudflare…',
  'domains.searchPlaceholderAdmin': 'Tìm tên miền, chủ sở hữu, kết nối Cloudflare…',
  'domains.filterPlanLabel': 'Lọc theo gói',
  'domains.filterPlanAll': 'Mọi gói',
  'domains.colName': 'Tên miền',
  'domains.colOwner': 'Chủ sở hữu',
  'domains.colStatus': 'Trạng thái',
  'domains.colPlan': 'Gói',
  'domains.colRecords': 'Bản ghi',
  'domains.colShares': 'Chia sẻ',
  'share.cell.title': '{n} người đang giữ quyền · {p} lời mời đang chờ',
  'share.cell.pendingShort': '+{p} chờ',
  'domains.colConnection': 'Kết nối Cloudflare',
  'domains.colUpdated': 'Cập nhật',
  'domains.colActions': 'Thao tác',
  'domains.open': 'Mở',
  'domains.page': 'Trang {page} · {total} tên miền',
  'domains.emptyTitle': 'Chưa có tên miền nào',
  'domains.emptyBody': 'Thêm tên miền đầu tiên để bắt đầu quản lý vùng DNS.',
  'domains.emptyFilterTitle': 'Bộ lọc không khớp tên miền nào',
  'domains.emptyFilterBody': 'Thử bỏ bớt điều kiện lọc hoặc xoá từ khoá tìm kiếm.',
  'domains.emptyScopeTitle': 'Bạn chưa có quyền xem tên miền nào',
  'domains.emptyScopeBody': 'Tên miền chỉ hiện khi bạn tự thêm hoặc được người khác cấp quyền.',
  'domains.status.active': 'Đang hoạt động',
  'domains.status.pending': 'Chờ nameserver',
  'domains.status.paused': 'Tạm dừng',
  'domains.status.moved': 'Đã chuyển đi',
  'domains.status.error': 'Lỗi',
  'domains.relation.owned': 'Bạn đã thêm',
  'domains.relation.granted': 'Được cấp',
  'domains.addTitle': 'Thêm tên miền',
  'domains.addSub': 'Vùng DNS sẽ được tạo trên Cloudflare và gán vào tài khoản của bạn.',
  'domains.nameLabel': 'Tên miền gốc',
  'domains.namePlaceholder': 'vidu.com.vn',
  'domains.nameHint': 'Nhập tên miền gốc, không kèm http:// hay www.',
  'domains.planLabel': 'Gói Cloudflare',
  'domains.assignLabel': 'Gán cho người dùng',
  'domains.assignSelf': '— Chính tôi —',
  'domains.assignHint':
    'Quản trị viên có thể thêm tên miền thay cho người dùng khác; danh sách kết nối lọc lại theo người đó.',
  'domains.cfAccountLabel': 'Tài khoản Cloudflare',
  'domains.cfAccountHint':
    'Token của kết nối này chạm tới nhiều tài khoản — chọn tài khoản sẽ chứa vùng DNS.',
  'domains.cfAccountNsHint':
    'Tên miền hiện có của tài khoản này phần lớn dùng {ns}. Nameserver chính thức của tên miền mới sẽ hiện ở bước 2.',
  'domains.cfAccountZones': '{n} tên miền',
  'domains.nsHintAll':
    'Cả {n} tên miền hiện có của “{name}” đều dùng cặp nameserver này. Cloudflare chốt con số chính thức ở bước 2.',
  'domains.nsHintMost':
    '{n}/{tong} tên miền của “{name}” dùng cặp này — Cloudflare gán theo từng vùng DNS nên có thể khác. Lấy con số chính thức ở bước 2 rồi mới đổi tại nhà đăng ký.',
  'domains.nsUnknown':
    'Tài khoản này chưa có tên miền nào nên chưa đoán được nameserver. Cloudflare sẽ trả về ngay sau khi tạo, ở bước 2.',
  'domains.connectionLabel': 'Kết nối Cloudflare',
  'domains.connectionHintOne': 'Tên miền sẽ được tạo trên kết nối duy nhất của tài khoản này.',
  'domains.connectionHintOneSelf': 'Tên miền sẽ được tạo trên kết nối duy nhất của bạn.',
  'domains.connectionHintMany': 'Chọn tài khoản Cloudflare sẽ chứa vùng DNS của tên miền này.',
  'domains.connectionHintNone':
    'Chưa có kết nối riêng — đang dùng tài khoản Cloudflare mặc định của hệ thống.',
  'domains.connectionFallback':
    'Người này chưa có kết nối Cloudflare riêng. Vùng DNS sẽ được tạo trên tài khoản mặc định của hệ thống — {name}.',
  /* Cùng chuyện, nhưng người đọc là chủ tên miền chứ không phải người thêm hộ
     (OQ-326). Xưng "bạn" cho đúng người đang ngồi trước màn hình. */
  'domains.connectionFallbackSelf':
    'Bạn chưa có kết nối Cloudflare riêng. Vùng DNS sẽ được tạo trên tài khoản mặc định của hệ thống — {name}.',
  'domains.connectionNone':
    'Chưa có kết nối Cloudflare nào dùng được. Hãy thêm kết nối riêng hoặc nhờ quản trị viên đặt kết nối mặc định hệ thống.',
  'domains.connectionAdd': 'Thêm kết nối riêng',
  'domains.scanRecords': 'Nhập sẵn bản ghi DNS hiện có',
  'domains.scanRecordsSub': 'Quét bản ghi đang hoạt động của tên miền trước khi chuyển nameserver.',
  'domains.addStep': 'Bước 1/2 · Xác minh nameserver ở bước sau',
  'domains.nsTitle': 'Trỏ nameserver để kích hoạt',
  'domains.nsSub':
    'Vào trang quản lý tên miền tại nhà đăng ký và thay nameserver hiện tại bằng hai giá trị dưới đây.',
  'domains.nsLabel': 'Nameserver cần trỏ',
  'domains.nsRecheck': 'Kiểm tra lại',
  'domains.nsPending': 'Nameserver chưa trỏ đúng. Cập nhật có thể mất tới 24 giờ.',
  'domains.nsActive': 'Tên miền đã kích hoạt trên Cloudflare.',
  'domains.created': 'Đã thêm {name}. Hãy trỏ nameserver để kích hoạt.',
  'domains.synced': 'Đã đồng bộ: thêm {added}, cập nhật {updated}, gỡ {removed} bản ghi.',
  'domains.deleteTitle': 'Gỡ tên miền khỏi hệ thống',
  'domains.deleteWarn':
    'DNSHub sẽ ngừng đọc và ghi vùng DNS này. Vùng trên Cloudflare vẫn giữ nguyên, bạn có thể thêm lại sau.',
  'domains.deleteConfirm': 'Nhập tên miền để xác nhận',
  'domains.deleted': 'Đã gỡ tên miền khỏi hệ thống.',

  // ── M4 · Chi tiết tên miền (FR-030…045) ──────────────────
  'detail.back': '← Tên miền',
  'detail.switch': 'Chuyển sang tên miền khác',
  'detail.switchSearch': 'Tìm tên miền bạn quản lý…',
  'detail.switchAll': 'Xem tất cả tên miền',
  'detail.switchEmpty': 'Không có tên miền nào khớp.',
  'detail.lede': 'Vùng DNS đồng bộ với Cloudflare {when} · {count} bản ghi · chủ sở hữu {owner}.',
  'detail.ledeNoSync': 'Vùng DNS chưa đồng bộ · {count} bản ghi.',
  'detail.export': 'Xuất zone file',
  'detail.import': 'Nhập zone file',
  'detail.purge': 'Xoá cache',
  'detail.addRecord': 'Thêm bản ghi',
  'detail.tab.dns': 'Bản ghi DNS',
  'detail.tab.overview': 'Tổng quan',
  'detail.tab.ssl': 'SSL/TLS',
  'detail.tab.access': 'Quyền truy cập',
  'detail.tab.log': 'Nhật ký',
  'detail.lockedPending':
    'Tên miền chưa kích hoạt vì nameserver chưa trỏ về Cloudflare. Trỏ nameserver tại nhà đăng ký theo hai giá trị bên dưới rồi bấm “Kiểm tra lại”. Bản ghi DNS vẫn dựng trước được — Cloudflare nhận ngay khi nameserver trỏ đúng.',
  'detail.lockedMoved':
    'Cloudflare báo tên miền này không còn trỏ về nameserver của họ, nên thay đổi DNS chưa có tác dụng cho tới khi trỏ lại. Dùng hai giá trị bên dưới rồi bấm “Kiểm tra lại”.',
  'detail.zoneInfo': 'Thông tin vùng',
  'detail.zoneId': 'Zone ID',
  'detail.owner': 'Chủ sở hữu',
  'detail.connection': 'Kết nối Cloudflare',
  'detail.cfAccount': 'Tài khoản Cloudflare',
  'detail.plan': 'Gói',
  'detail.createdAt': 'Ngày thêm',
  'detail.lastSync': 'Đồng bộ gần nhất',
  'detail.nameservers': 'Nameserver',
  'detail.originalNs': 'Nameserver ban đầu',
  'detail.danger': 'Vùng nguy hiểm',
  'detail.pause': 'Tạm dừng Cloudflare',
  'detail.pausedReasonLabel': 'Lý do tạm dừng',
  'detail.syncPausedLabel': 'Đồng bộ',
  'detail.syncPause': 'Tạm dừng đồng bộ',
  'detail.syncResume': 'Bật lại đồng bộ',
  'detail.syncPaused': 'Ngừng đồng bộ',
  'detail.syncPausedHint':
    'DNSHub không đọc/ghi tên miền này nữa. Cloudflare không đổi gì — website vẫn chạy bình thường.',
  'detail.syncPauseConfirm':
    'Tạm dừng đồng bộ {name}? DNSHub sẽ ngừng đọc và ghi tên miền này: bản ghi DNS không sửa được từ đây, các tác vụ nền bỏ qua nó.',
  'detail.syncPauseUndo':
    'Website của bạn KHÔNG bị ảnh hưởng — Cloudflare giữ nguyên mọi thứ. Bật lại bất cứ lúc nào.',
  'detail.syncPausedDone': 'Đã tạm dừng đồng bộ {name}.',
  'detail.syncResumedDone': 'Đã bật lại đồng bộ {name}.',
  'detail.pausedReason.manual': 'Bạn đã tạm dừng tên miền này trên Cloudflare.',
  'detail.pausedReason.orphaned':
    'Không còn kết nối Cloudflare nào — hãy nối lại một kết nối để dùng tiếp.',
  'detail.pausedReason.zone_missing':
    'Vùng này không còn tồn tại trên Cloudflare. Nối lại kết nối cũng không giúp được.',
  'detail.pausedReason.cloudflare':
    'Tên miền bị tạm dừng từ bảng điều khiển Cloudflare, không phải từ DNSHub.',
  'detail.syncPausedReason.manual': 'Bạn đã tạm dừng đồng bộ riêng tên miền này.',
  'detail.syncPausedReason.connection':
    'Kết nối Cloudflare đang tạm ngưng nên mọi tên miền của nó cũng ngừng đồng bộ.',
  'detail.pauseConfirm':
    'Tạm dừng Cloudflare cho {name}? Lưu lượng sẽ đi thẳng tới máy chủ gốc — CDN, WAF và cache ngừng hoạt động, IP gốc lộ ra.',
  'detail.pauseUndo':
    'Bật lại bất cứ lúc nào bằng nút "Bật lại Cloudflare". Bản ghi DNS không đổi.',
  'detail.resumeConfirm':
    'Bật lại Cloudflare cho {name}? Lưu lượng sẽ đi qua mạng Cloudflare trở lại.',
  'detail.resumeUndo': 'Có hiệu lực sau vài giây nhờ mạng anycast.',
  'roles.resetConfirm': 'Đặt lại vai trò {name} về mặc định? Mọi quyền đã tuỳ chỉnh sẽ mất.',
  'roles.resetUndo': 'Không hoàn tác được — bạn sẽ phải chọn lại từng quyền.',
  'profile.sessions.endOthersConfirm':
    'Đăng xuất mọi thiết bị khác? Các phiên đang mở trên máy khác sẽ bị kết thúc ngay.',
  'profile.sessions.endOthersUndo':
    'Phiên hiện tại không bị ảnh hưởng. Thiết bị khác cần đăng nhập lại.',
  'detail.resume': 'Bật lại Cloudflare',
  'detail.remove': 'Xoá tên miền khỏi hệ thống',
  'detail.paused': 'Đã tạm dừng Cloudflare cho {name}.',
  'detail.resumed': 'Đã bật lại Cloudflare cho {name}.',
  'detail.purged': 'Đã gửi yêu cầu xoá cache.',
  'detail.notAllowed': 'Bạn không có quyền thực hiện thao tác này trên tên miền này.',

  // ── M4 · Bản ghi DNS (FR-034…041) ────────────────────────
  'dns.colType': 'Loại',
  'dns.colName': 'Tên',
  'dns.colContent': 'Giá trị',
  'dns.colProxy': 'Proxy',
  'dns.colTtl': 'TTL',
  'dns.colUpdated': 'Cập nhật',
  'dns.searchPlaceholder': 'Tìm tên, giá trị hoặc ghi chú…',
  'dns.notProxiable': 'Không áp dụng',
  'dns.ttlAuto': 'Tự động',
  'dns.emptyTitle': 'Vùng DNS chưa có bản ghi nào',
  'dns.emptyBody': 'Thêm bản ghi đầu tiên hoặc đồng bộ lại từ Cloudflare.',
  'dns.emptyFilter': 'Không có bản ghi nào khớp bộ lọc.',
  'dns.recordTitle': 'Bản ghi DNS',
  'dns.recordSub': '{name} · thay đổi có hiệu lực gần như tức thì',
  'dns.type': 'Loại',
  'dns.name': 'Tên',
  'dns.namePlaceholder': 'www hoặc @ cho tên miền gốc',
  'dns.content': 'Giá trị',
  'dns.contentHint': 'Với CNAME hãy nhập tên miền đích, ví dụ app.vercel.app',
  'dns.ttl': 'TTL',
  'dns.priority': 'Độ ưu tiên',
  'dns.proxy': 'Proxy qua Cloudflare',
  'dns.proxySub': 'Ẩn IP gốc, bật CDN và WAF cho bản ghi này. TTL sẽ về Tự động.',
  'dns.comment': 'Ghi chú',
  'dns.commentHint':
    'Ghi chú này được lưu lên Cloudflare cùng bản ghi — ai xem bản ghi trên Cloudflare cũng đọc được.',
  'dns.commentPlaceholder': 'Ví dụ: trỏ về cụm web Hà Nội',
  'dns.srvService': 'Service',
  'dns.srvProto': 'Proto',
  'dns.srvWeight': 'Weight',
  'dns.srvPort': 'Port',
  'dns.srvTarget': 'Target',
  'dns.caaFlags': 'Flags',
  'dns.caaTag': 'Tag',
  'dns.caaValue': 'Value',
  'dns.save': 'Lưu bản ghi',
  'dns.created': 'Đã thêm bản ghi DNS.',
  'dns.updated': 'Đã lưu bản ghi DNS.',
  'dns.deleted': 'Đã xoá bản ghi DNS.',
  'dns.deletedUndo': 'Đã xoá {name}. Hoàn tác trong 10 giây.',
  'dns.deleteTitle': 'Xác nhận xoá',
  'dns.deleteSub': 'Hành động này không thể hoàn tác.',
  'dns.deleteWarn': 'Dịch vụ đang dùng bản ghi này có thể ngừng hoạt động trong vài phút.',
  'dns.deleteConfirmLabel': 'Xoá bản ghi {type} {name}?',
  'dns.proxyOn': 'Đã bật proxy cho {name}.',
  'dns.proxyOff': 'Đã tắt proxy cho {name}.',
  'dns.footNote': 'Thay đổi bản ghi có hiệu lực sau vài giây nhờ mạng anycast của Cloudflare.',

  // ── M4 · SSL/TLS (FR-042) ────────────────────────────────
  'ssl.note': 'Chứng chỉ Universal SSL do Cloudflare cấp, tự động gia hạn trước 30 ngày.',
  'ssl.modeTitle': 'Chế độ mã hoá',
  'ssl.modeSub': 'Cách Cloudflare kết nối tới máy chủ gốc',
  'ssl.modeLabel': 'Chế độ đang dùng',
  'ssl.mode.off': 'Off',
  'ssl.mode.flexible': 'Flexible',
  'ssl.mode.full': 'Full',
  'ssl.mode.strict': 'Full (strict)',
  'ssl.mode.offSub': 'Không mã hoá giữa trình duyệt và Cloudflare.',
  'ssl.mode.flexibleSub': 'Mã hoá tới Cloudflare, không mã hoá tới máy chủ gốc.',
  'ssl.mode.fullSub': 'Mã hoá đầu-cuối, chấp nhận chứng chỉ tự ký ở máy chủ gốc.',
  'ssl.mode.strictSub':
    'Mã hoá đầu-cuối và yêu cầu chứng chỉ hợp lệ ở máy chủ gốc. Khuyến nghị cho môi trường sản xuất.',
  'ssl.alwaysHttps': 'Luôn dùng HTTPS',
  'ssl.alwaysHttpsSub': 'Chuyển hướng mọi yêu cầu HTTP sang HTTPS.',
  'ssl.hsts': 'HSTS',
  'ssl.hstsSub': 'Buộc trình duyệt chỉ truy cập qua HTTPS trong khoảng thời gian đã đặt.',
  'ssl.hstsMaxAge': 'max-age (giây)',
  'ssl.hstsSubdomains': 'Áp dụng cho tên miền con',
  'ssl.hstsPreload': 'Đăng ký danh sách preload',
  'ssl.minTls': 'TLS tối thiểu',
  'ssl.minTlsSub': 'Từ chối kết nối dùng giao thức cũ hơn.',
  'ssl.certTitle': 'Chứng chỉ đang hoạt động',
  'ssl.certExpires': 'Hết hạn',
  'ssl.certNone': 'Chưa đọc được thông tin chứng chỉ. Hãy đồng bộ lại.',
  'ssl.saved': 'Đã lưu cấu hình SSL/TLS.',
  'ssl.purgeTitle': 'Xoá cache Cloudflare',
  'ssl.purgeAll': 'Xoá toàn bộ cache',
  'ssl.purgeAllSub': 'Mọi tài nguyên tĩnh sẽ được tải lại từ máy chủ gốc.',
  'ssl.purgeFiles': 'Hoặc nhập danh sách đường dẫn, mỗi dòng một URL',

  // ── M4 · Nhập zone file (FR-039) ─────────────────────────
  'import.title': 'Nhập zone file (BIND)',
  'import.sub': 'Dán nội dung tệp zone. Hệ thống hiện bản xem trước trước khi áp dụng.',
  'import.content': 'Nội dung tệp zone',
  'import.preview': 'Xem trước',
  'import.apply': 'Áp dụng thay đổi',
  'import.summary': 'Thêm mới {create} · Cập nhật {update} · Bỏ qua {skip}',
  'import.skippedLines': '{count} dòng không đọc được',
  'import.action.create': 'Thêm mới',
  'import.action.update': 'Cập nhật',
  'import.action.skip': 'Bỏ qua',
  'import.applied': 'Đã nhập: thêm {created}, cập nhật {updated}.',
  'import.failed': '{count} bản ghi không áp dụng được.',

  /* ── Cloudflare Tunnel — OQ-337 ─────────────────────────────────── */
  'tunnel.button': 'Tunnel',
  'tunnel.title': 'Cloudflare Tunnel',
  'tunnel.subtitle': 'Kết nối {name}',
  'tunnel.intro':
    'Tunnel cho phép máy chủ của bạn nhận lưu lượng qua Cloudflare mà không cần mở cổng hay có IP tĩnh. Hệ thống này tạo và cấu hình tunnel; bạn tự chạy cloudflared trên máy chủ.',
  'tunnel.newName': 'Tên tunnel mới',
  'tunnel.newNamePlaceholder': 'vi-du-may-chu-web',
  'tunnel.create': 'Tạo tunnel',
  'tunnel.created': 'Đã tạo tunnel.',
  'tunnel.deleted': 'Đã xoá tunnel.',
  'tunnel.emptyTitle': 'Chưa có tunnel nào',
  'tunnel.emptyHint': 'Tạo tunnel đầu tiên để đưa dịch vụ nội bộ ra Internet qua Cloudflare.',
  'tunnel.colName': 'Tên',
  'tunnel.colStatus': 'Trạng thái',
  'tunnel.colConns': 'Máy đang nối',
  'tunnel.colHostname': 'Tên miền',
  'tunnel.colService': 'Dịch vụ nội bộ',
  'tunnel.actions': 'Thao tác',
  'tunnel.status.inactive': 'Chưa chạy',
  'tunnel.status.healthy': 'Đang chạy',
  'tunnel.status.degraded': 'Chập chờn',
  'tunnel.status.down': 'Mất kết nối',
  'tunnel.local': 'Cấu hình tại máy',
  'tunnel.localHint':
    'Tunnel này được cấu hình bằng tệp trên máy chạy cloudflared, nên không sửa được từ đây. Sửa tệp config.yml trên máy đó.',
  'tunnel.setup': 'Chi tiết',
  'tunnel.setupTitle': 'Cài đặt tunnel {name}',
  'tunnel.inactiveNote':
    'Tunnel đã tạo trên Cloudflare nhưng CHƯA có máy nào chạy. Nó chưa phục vụ được lưu lượng cho tới khi bạn làm xong bước 1.',
  'tunnel.step1': 'Bước 1 — Chạy cloudflared trên máy chủ của bạn',
  'tunnel.step1Hint': 'Lấy lệnh cài đặt rồi dán vào máy chủ sẽ chạy tunnel.',
  'tunnel.showToken': 'Lấy lệnh cài đặt',
  'tunnel.tokenWarn':
    'Lệnh dưới đây chứa token — ai có nó đều biến máy của họ thành lối ra của tunnel này. Chỉ dán vào máy chủ của bạn, đừng gửi qua chat hay email.',
  'tunnel.dockerAlt': 'Hoặc chạy bằng Docker:',
  'tunnel.step2': 'Bước 2 — Trỏ tên miền',
  'tunnel.step2Hint':
    'Thêm bản ghi CNAME trỏ tới {target} và bật proxy (đám mây cam) ở trang Tên miền.',
  'tunnel.step3': 'Bước 3 — Khai dịch vụ nội bộ',
  'tunnel.addRule': 'Thêm dòng',
  'tunnel.configSaved': 'Đã lưu cấu hình tunnel.',
  'tunnel.advancedCount': '{count} tuỳ chọn nâng cao',
  'tunnel.advancedHint':
    'Dòng này còn cấu hình nâng cao đặt trên Cloudflare. Bấm để xem — hệ thống giữ nguyên chúng khi bạn lưu.',
  'tunnel.advancedTitle': 'Tuỳ chọn nâng cao',
  'tunnel.advancedReadOnly':
    'Các tuỳ chọn này đặt trên Cloudflare và chỉ xem được ở đây. Hệ thống giữ nguyên chúng khi bạn lưu; muốn sửa thì vào Cloudflare → Zero Trust → Networks → Tunnels.',
  'tunnel.advancedCol': 'Tuỳ chọn',
  'tunnel.advancedVal': 'Giá trị',
  'tunnel.advancedAll':
    'Tunnel này còn {count} tuỳ chọn nâng cao áp cho mọi dòng, đặt trên Cloudflare. Hệ thống giữ nguyên khi bạn lưu.',
};
